import React, {Component} from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import moment from "moment";
import * as ReactBootStrap from 'react-bootstrap';

import Departamentos from '../API/Departamentos';
import Publicaciones from './Publicaciones_prestador'

import telefono from '../tools/images/icono telefono whatsApp.svg'

import platinium from '../tools/images/PLATINIUM.png'
import golden from '../tools/images/GOLDEN.png'
import diamond from '../tools/images/DIAMOND.png'
import silver from '../tools/images/Silver-profesional-1.png'

import paso1 from '../tools/images/paso1compra.svg'
import paso2 from '../tools/images/paso2compra.svg'
import paso3 from '../tools/images/paso3compra.svg'
import card_credit from '../tools/images/credit-card.svg';
import pse from '../tools/images/pse.png';
import bancolombia from '../tools/images/bancolombia.png';
import nequi from '../tools/images/nequi.png';

import '../tools/css/Perfil.css';

import iconofotoportada from '../tools/images/iconocargarfoto.svg'
import iconofotoavatar from '../tools/images/icono cargar foto perfil panel.svg'

import cargamultimedia from '../tools/images/iconocargarfoto.svg'

import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/styles.css';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';


import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

const ApiURL="https://medicallapi.azurewebsites.net/";
var institution_id =sessionStorage.getItem('id_institution');
var avatar=[];
var cover=[];
var mensaje='';
var files_view='';
var files_viewp='';
var muni='';
var idmuni_edit='0';
var depa='';
var iddepa_edit='0';
var claseprestador_edit='';
var naturaleza_edit='';
var nivelatencion_edit='0';
var ese='No';
var ese_edit=null;
var tipoidrl_edit=null;
var url='';
var url_pse='';
var tipo_membresia='0';
var metodo_pago='';
var tipo_persona='';
var status='';
var valor = 0;
var iva = 0;




class Perfil extends Component {

  constructor(props)
    {
     super()
      this.state={
        show:false,
        DataIntitucion: [],    
        DataMembresia: [],   
        Membresia:[],
        Detalle_membresia:[],
        Detalle_compra:[],
        Pager_Publicacione: [],
        imgs:[],
        Departamentos: [],
        Municipios:[],
        Bancos:[],
        pager_infopublicacione:'',
        loading: false,
        loading_recurso:false,
        loading_button: true,
        active_button: true,
        loading_button_img: true,
        active_button_img: true,
          
        form:{ 
        id_inst:'',  
        nombre_edit:"",
        nombre1_edit:"",
        nombre2_edit:"",
        apell1_edit:"",
        apell2_edit:"",
        codigoprestador_edit:'',       
        correo_edit:'',
        web_edit:'',
        dir_edit:'',
        tel1_edit:'',
        tel2_edit:'',
        idrl_edit:'',
        nom1rl_edit:"",
        nom2rl_edit:"",
        apell1rl_edit:"",
        apell2rl_edit:"",
        selectedFile:null,
        selectedFilep:null,
        claseprestado:'',
        nivelatencion:'',
        municipio:'',
        departamento:'',
        llave_publi:'',
        llave_priv:'',
        llave_eventos:'',
        llave_integridad:'',
        tipoid_comprador_general:'null',
        id_comprador_general:'',
        nombres_comprador_general:'',
        apellidos_comprador_general:'',
        correo_comprador_general:'',
        dir_comprador_general:'',
        tel_comprador_general:'',
        num_tc:'',
        tarjetahabiente:'',
        mes_tc:'',
        year_tc:'',
        cuotas_tc:'1',
        cod_tc:'',
        tipodcto_pse:'CC',
        numerodcto_pse:'',
        id_banco_pse:'',
        cel_nequi:'',
        cod_membresia1:'',
        cod_membresia2:'',
        cod_membresia3:'',
        cod_membresia4:'',
        cod_membresia5:''
        
        }
        
      }
    }



    handleChange=async e=>{
      await this.setState({
         form:{
              ...this.state.form,
              [e.target.name]: e.target.value
              }
         })
         //console.log(this.state.form);
    } 

    Campo_numerico(){
      $(".camponum").keypress(function(tecla)
      {
        if(tecla.charCode<48 || tecla.charCode>57){
         
          return false;

        }
      })
    }


    GetImg = (i) =>{      
      this.setState({selectedFile:i.target.files})
      avatar=i.target.files[0]
      files_view=URL.createObjectURL(i.target.files[0]); 
       
      this.modal_img_perfil() 
      //alert(avatar)
    }

    GetImg_portada = (ip) =>{     
      this.setState({selectedFilep:ip.target.files})
      cover=ip.target.files[0]
      files_viewp=URL.createObjectURL(ip.target.files[0]);
      
      this.modal_img_portada() 
      //alert(cover)
    }


    modal_img_perfil(){
      $('#modal_img_perfil').modal('show'); 
    }

    modal_img_portada(){
      $('#modal_img_portada').modal('show'); 
    }

    modal_detalle_silver_independiente(){
      $('#modal_detalle_silver_independiente').modal('show'); 
    }

    modal_detalle_golden_independiente(){
      $('#modal_detalle_golden_independiente').modal('show'); 
    }

    modal_detalle_platinum_institucion(){
      $('#modal_detalle_platinum_institucion').modal('show'); 
    }

    modal_detalle_golden_institucion(){
      $('#modal_detalle_golden_institucion').modal('show'); 
    }

    modal_detalle_diamond_institucion(){
      $('#modal_detalle_diamond_institucion').modal('show'); 
    }


    modal_comprar_membresia(tipo_membresia){

      $('#modal_detalle_silver_independiente').modal('hide'); 
      $('#modal_detalle_golden_independiente').modal('hide'); 
      $('#modal_detalle_platinum_institucion').modal('hide');
      $('#modal_detalle_golden_institucion').modal('hide'); 
      $('#modal_detalle_diamond_institucion').modal('hide');
      
      axios.get(ApiURL+"/api/Products/GetById/"+tipo_membresia)
      .then((response) => {
        console.log(response.data);
        this.setState({Detalle_membresia: response.data}) 

        $('#modal-compramembresia').modal('show'); 

      })
      .catch((error) => {
        console.log(error);
      })     

    }

    modal_activamembresia(){      
      $('#modal-activarmembresia').modal('show');
      $("#modal-activarmembresia input").val("");
      
      //this.setState({ active_buttonrecovery_pass: this.state.active_buttonrecovery_pass = true })
    }

    modal_llavesWOMPI(){   
      
      $('#modal-llaveswompi').modal('show'); // <- to show modal llaves wompi
    }

   

    dropmodal_comprar_membresia() {

      $("#modal-compramembresia input").val("");
      $("#modal-compramembresia input[type='radio']").prop('checked', false).change();      
      $("#tipoid_comprador_general").val($('#tipoid_comprador_general > option:first').val());
      $("#mes_tc").val($('#mes_tc > option:first').val());
      $("#year_tc").val($('#year_tc > option:first').val());
      $("#cuotas_tc").val($('#cuotas_tc > option:first').val());
      $("#cuotas_tc").val($('#cuotas_tc > option:first').val());
      $("#tipo_persona_pse").val($('#tipo_persona_pse > option:first').val());
      $("#id_banco_pse").val($('#id_banco_pse > option:first').val());


      this.setState({
        form:{
          tipoid_comprador_general:'null',
          id_comprador_general:'',
          nombres_comprador_general:'',
          apellidos_comprador_general:'',
          correo_comprador_general:'',
          dir_comprador_general:'',
          tel_comprador_general:'',    
          num_tc:'',
          tarjetahabiente:'',
          mes_tc:'MM',
          year_tc:'YY',
          cuotas_tc:'1',
          cod_tc:'',
          tipodcto_pse:'CC',
          numerodcto_pse:'',
          id_banco_pse:'',
          cel_nequi:''     
        }
      }) 
      
      this.Drop_formularios_pagos();
    }

    handleModaleditinfo()
    { 
      this.cargar_departamentos();
      this.seleccionardatos();    
      $('#modal-infoinstotucion').modal('show'); // <- to show modal editar informacion de institucion
    }

    

    drop_view_img(){
      files_view=null
      files_viewp=null
    }   
    
    hidedepartamento(){
     
    }

    cargar_departamentos(){    
    
      axios.get("https://medicallapi.azurewebsites.net//api/Departments/ListDepartments")
      .then((response) => {
        //console.log(response);
        this.setState({Departamentos: response.data})

        $('#cb_departamento').hide();
      })
      .catch((error) => {
        //console.log(error);
      })
    } 


    GetDepartamento = (d) =>{
      console.log(d.target.value)
      iddepa_edit=(d.target.value)  
      this.Cargar_Municipios(iddepa_edit)

      idmuni_edit='0';
      muni='Seleccione...'
    }

    GetMunicipio = (m) =>{
     
      console.log(m.target.value)
      idmuni_edit=(m.target.value)  
     
    }

    GetClasepres = (cp) =>{     
      console.log(cp.target.value)
      claseprestador_edit=(cp.target.value)

      $('#cb_claseprestador').hide();
      //this.Cuota_mod();
     
    }

    GetTipoNatu = (tn) =>{
 
      console.log(tn.target.value)
      naturaleza_edit=(tn.target.value)

      $('#cb_naturaleza').hide();
      //this.Cuota_mod();
     
    }

    GetNivel = (n) =>{
     
      console.log(n.target.value)
      nivelatencion_edit=(n.target.value)  

      $('#cb_nivel').hide();     
    }

    GetESE = (e) =>{
      
      console.log(e.target.value)
      ese_edit=(e.target.value) 

      $('#cb_ese').hide();      
    }

    GetTipoIDLD = (tild) =>{
     
      console.log(tild.target.value)
      tipoidrl_edit=(tild.target.value)

      $('#cb_tipoid_rl').hide();
    }

    GetMetodopago = (mp) =>{
     
      //console.log(mp.target.value)
      metodo_pago=(mp.target.value)

      this.Formulario_metodopago();
     
    }

    GetTipopersona = (tp) =>{
     
      //console.log(tp.target.value)
      tipo_persona=(tp.target.value)
    
     
    }

    Formulario_metodopago(){     
      if(metodo_pago==='CARD'){
  
        $('#tarjeta_credito').show();
        $('#pse').hide();
        $('#bancolombia').hide();
        $('#nequi').hide();


      }else{

        if(metodo_pago==='PSE'){

          $('#tarjeta_credito').hide();
          $('#pse').show();
          $('#bancolombia').hide();
          $('#nequi').hide();

          tipo_persona='';

          $("#tipo_persona_pse").val($('#tipo_persona_pse > option:first').val());

        }else{

          if(metodo_pago==='BANCOLOMBIA_TRANSFER'){

            $('#tarjeta_credito').hide();
            $('#pse').hide();           
            $('#nequi').hide();

            tipo_persona='PERSON';

            $("#tipo_persona_pse").val($('#tipo_persona_pse > option:first').val());

         

          }else{

            if(metodo_pago==='NEQUI'){

              $('#tarjeta_credito').hide();
              $('#pse').hide();
              $('#bancolombia').hide();
              $('#nequi').show();

            }
          }
        }
      }
      
    }


    Datos_formulario_metodopago(){     
      if(metodo_pago==='CARD'){
  
        ese_edit=this.state.DataIntitucion.ese


      }else{

        if(metodo_pago==='PSE'){

          $('#tarjeta_credito').hide();
          $('#pse').show();
          $('#bancolombia').hide();
          $('#nequi').hide();

        }else{

          if(metodo_pago==='BANCOLOMBIA_TRANSFER'){

            $('#tarjeta_credito').hide();
            $('#pse').hide();
            $('#bancolombia').show();
            $('#nequi').hide();

          }else{

            if(metodo_pago==='NEQUI'){

              $('#tarjeta_credito').hide();
              $('#pse').hide();
              $('#bancolombia').hide();
              $('#nequi').show();

            }
          }
        }
      }
      
    }

    Drop_formularios_pagos(){

              $('#img_paso1').show();
              $('#img_paso2').hide();

              $('#compra_paso1').show();
              $('#compra_paso2').hide();

              $('#btn_compra_paso1').show();
              $('#btn_compra_paso2').hide();


              $('#tarjeta_credito').hide();
              $('#pse').hide();
              $('#bancolombia').hide();
              $('#nequi').hide();


    }


    Cargar_bancos(){    
    
      axios.get(ApiURL+"/api/Payments/FinancialInstitutions")
      .then((response) => {
        //console.log(response);
        this.setState({Bancos: response.data.data})
      })
      .catch((error) => {
        console.log(error);
      })
    }

    Cargar_membresias(){    
    
      axios.get(ApiURL+"/api/Memberships/GetMembershipPlans")
      .then((response) => {
        console.log(response.data);
        this.setState({Membresia: response.data})
      })
      .catch((error) => {
        console.log(error);
      })
    }

  
    Cargar_Municipios(iddepa_edit){    
        
      axios.get(ApiURL+"/api/Departments/ListMunicipalties/"+iddepa_edit)
      .then((response) => {
        console.log(response);
        this.setState({Municipios: response.data})

        $('#cb_municipio').hide();
        $('#cb_municipio_seleccione').show();
        
      })
      .catch((error) => {
        console.log(error);
      })
    }  


   
    componentDidMount(){
      this.Datos_Institucion();
      this.Cargar_bancos();

      $('[data-toggle="tooltip"]').tooltip()
      $('#cb_municipio_seleccione').hide();

      $('#tarjeta_credito').hide();
      $('#pse').hide();
      $('#bancolombia').hide();
      $('#nequi').hide();
      $('#compra_paso2').hide();
      $('#compra_paso3').hide();
      $('#btn_compra_paso2').hide();  
      $('#btn_compra_paso3').hide();  
      $('#img_paso2').hide();  

      $('#institucion').hide();
      $('#independiente').hide();
          
      
    }

    validar_paso1(){

      if( this.state.form.tipoid_comprador_general=='null' || this.state.form.id_comprador_general.length==0 || this.state.form.nombres_comprador_general.length==0 || this.state.form.apellidos_comprador_general.length==0 || this.state.form.dir_comprador_general.length==0 || this.state.form.tel_comprador_general.length==0){
  
        store.addNotification({
          title: 'Atención',
          message: "Faltan datos del comprador por ingresar",
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

      }else{

        $('#img_paso1').hide();
        $('#img_paso2').show();

        $('#compra_paso1').hide();
        $('#compra_paso2').show();
  
        $('#btn_compra_paso1').hide();
        $('#btn_compra_paso2').show();

      }

      
    
    }

    atras(){

      $('#img_paso1').show();
      $('#img_paso2').hide();

      $('#compra_paso1').show();
      $('#compra_paso2').hide();
      $('#compra_paso3').hide();

      $('#btn_compra_paso1').show();
      $('#btn_compra_paso2').hide();
      $('#btn_compra_paso3').hide();
    
    }

    atras3(){

      $('#img_paso1').show();
      $('#img_paso2').hide();

      $('#compra_paso1').hide();
      $('#compra_paso2').show();
      $('#compra_paso3').hide();

      $('#btn_compra_paso1').hide();
      $('#btn_compra_paso2').show();
      $('#btn_compra_paso3').hide();
    
    }


    Datos_Institucion(){    
      
      axios.get(ApiURL+"/api/Institutions/GetInstitution/"+institution_id)
      .then((response) => {
        console.log(response);
        this.setState({DataIntitucion: response.data.institution})       
        this.setState({DataMembresia: response.data.membership})

        iddepa_edit= response.data.institution.department.id
        this.setState({departamento: response.data.institution.department.nombre})
        depa=(this.state.departamento).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
   
        idmuni_edit= response.data.institution.municipality.id
        this.setState({municipio: response.data.institution.municipality.nombre})
        muni=(this.state.municipio).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))
     
        claseprestador_edit=this.state.DataIntitucion.providerClass
      
        naturaleza_edit=this.state.DataIntitucion.legalNature

        nivelatencion_edit=this.state.DataIntitucion.atentionLevel       

        tipoidrl_edit=this.state.DataIntitucion.tipeIdRepresentative

        if(this.state.DataIntitucion.providerClass=='ips'){
           this.setState({claseprestado: 'Instituciones - IPS'})
           $('#institucion').show();
           $('#independiente').hide();
        }else{
          if(this.state.DataIntitucion.providerClass=='profesional independiente'){
             this.setState({claseprestado: 'Profesional independiente'})
             $('#institucion').hide();
             $('#independiente').show();
          }
        }


        if(this.state.DataIntitucion.atentionLevel=='1'){
           this.setState({nivelatencion: 'Primer nivel'})
        }else{
          if(this.state.DataIntitucion.atentionLevel=='2'){
             this.setState({nivelatencion: 'Segundo nivel'})
          }else{
            if(this.state.DataIntitucion.atentionLevel=='3'){
               this.setState({nivelatencion: 'Tercer nivel'})
            }
          }
        }

        ese_edit=this.state.DataIntitucion.ese

        if(this.state.DataIntitucion.ese==false){
           ese='No'
       }else{
         if(this.state.DataIntitucion.ese==true){
            ese='Si'
         }
       }

       this.setState({
        form:{
         
          llave_priv:this.state.DataIntitucion.privateKey,
          llave_publi:this.state.DataIntitucion.publicKey
         
        }
      })

       if(this.state.DataMembresia.name=='MEMBRESIA PLATINIUM'){

        $('#platinium').hide();
        $('#golden').show();
        $('#diamond').hide();

        $('#platinium_in').hide();
        $('#golden_in').show();
        $('#diamond_in').hide();


       }else{

         if(this.state.DataMembresia.name=='MEMBRESIA GOLDEN'){

          $('#platinium').hide();
          $('#golden').hide();
          $('#diamond').show();

          $('#platinium_in').hide();
          $('#golden_in').hide();
          $('#diamond_in').show();

         }else{

          if(this.state.DataMembresia.name=='MEMBRESIA DIAMOND'){
            
            $('#actualiza_plan').hide();
            $('#platinium').hide();
            $('#golden').hide();
            $('#diamond').hide();

           
            $('#platinium_in').hide();
            $('#golden_in').hide();
            $('#diamond_in').hide();
  
           }else{

            $('#platinium').show();
            $('#golden').hide();
            $('#diamond').hide();

            $('#platinium_in').show();
            $('#golden_in').hide();
            $('#diamond_in').hide();

           }
         }
       }


        
      })
      .catch((error) => {
        console.log(error);
      })
    }


    seleccionardatos=()=>{

      this.Cargar_Municipios(iddepa_edit);

      this.setState({
        form:{
          nombre_edit:this.state.DataIntitucion.name,
          nombre1_edit:this.state.DataIntitucion.name1,
          nombre2_edit:this.state.DataIntitucion.name2,
          apell1_edit:this.state.DataIntitucion.lastName1,
          apell2_edit:this.state.DataIntitucion.lastName2,
          codigoprestador_edit:this.state.DataIntitucion.providerCode.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase()))),
          correo_edit:this.state.DataIntitucion.email,
          web_edit:this.state.DataIntitucion.web,
          dir_edit:this.state.DataIntitucion.address,
          tel1_edit:this.state.DataIntitucion.phone1,
          tel2_edit:this.state.DataIntitucion.phone2 ? this.state.DataIntitucion.phone2 : '',
          idrl_edit: this.state.DataIntitucion.idRepresentative,
          nom1rl_edit:this.state.DataIntitucion.nameRepresentative1 ? this.state.DataIntitucion.nameRepresentative1 : '' ,
          nom2rl_edit:this.state.DataIntitucion.nameRepresentative2 ? this.state.DataIntitucion.nameRepresentative2 : '',
          apell1rl_edit:this.state.DataIntitucion.lastNameRepresentative1 ? this.state.DataIntitucion.lastNameRepresentative1 : '',
          apell2rl_edit:this.state.DataIntitucion.lastNameRepresentative2 ? this.state.DataIntitucion.lastNameRepresentative2: '',
          tipoid_comprador_general:this.state.form.tipoid_comprador_general,
          llave_priv:this.state.form.llave_priv,
          llave_publi:this.state.form.llave_publi,
          llave_eventos:this.state.form.llave_eventos,
          llave_integridad:this.state.form.llave_integridad
         
        }
      })
      //var  dato  = solicitud.user.identification;
      //alert(dato);
    }


    subir_avatar=async()=>{
     
        
        this.setState({ loading_button_img: this.state.loading_button_img = false })
        this.setState({ active_button_img: this.state.active_button_img = false })

        let formData = new FormData();
        
        formData.append('avatar', avatar);
       

        await axios.put(ApiURL+"/api/Institutions/UploadAvatar", formData,{

          headers: {
            'Content-Type': 'multipart/form-data'            
          }

        })  
        .then(response=>{
          console.log(response.data)
          //var  mensaje  = response.data.message;
          //alert(mensaje);
          //const [text, setText] = LocalStorage(text, '')
          //setText(dato);
                 
          //window.location.href="/home";
        store.addNotification({
            title: 'Muy bien',
            message:'Su imagen de perfil ha sido cambiada',
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
            duration: 10000,
            showIcon:true
            }
          })

          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })

          $('#modal_img_perfil').modal('hide');
          this.Datos_Institucion();
          
          
        })
        .catch(error=>{
         
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            //console.log(error.response.data.message);
            //console.log(error.response.status);
            //console.log(error.response.headers);
            mensaje=error.response.data.message
            
            store.addNotification({
              title: 'Atención',
              message: 'Error al actualizar imagen',
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })

        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
            this.setState({ loading_button_img: this.state.loading_button_img = true })
            this.setState({ active_button_img: this.state.active_button_img = true })
        } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
            this.setState({ loading_button_img: this.state.loading_button_img = true })
            this.setState({ active_button_img: this.state.active_button_img = true })
        }
        //console.log(error.config);
      
      })
   
     }


     subir_portada=async()=>{
     
        
      this.setState({ loading_button_img: this.state.loading_button_img = false })
      this.setState({ active_button_img: this.state.active_button_img = false })

      let formData = new FormData();
      
      formData.append('avatar', cover);
     

      await axios.put(ApiURL+"/api/Institutions/UploadCover", formData,{

        headers: {
          'Content-Type': 'multipart/form-data'            
        }

      })  
      .then(response=>{
        console.log(response.data)
        //var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message:'Su imagen de portada ha sido cambiada',
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button_img: this.state.loading_button_img = true })
        this.setState({ active_button_img: this.state.active_button_img = true })

        $('#modal_img_portada').modal('hide');
        this.Datos_Institucion();
        
        
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: 'Error al actualizar imagen',
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

        this.setState({ loading_button_img: this.state.loading_button_img = true })
        this.setState({ active_button_img: this.state.active_button_img = true })

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button_img: this.state.loading_button_img = true })
          this.setState({ active_button_img: this.state.active_button_img = true })
      }
      //console.log(error.config);
    
    })
 
   }



   saveinstitution=async()=>{

    if(this.state.form.nombre_edit.length==0 ){

      store.addNotification({
        title: 'Atención',
        message: "Faltan datos de la institución... verifique!!!",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })

    }else{
      
      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })

      let formData = new FormData();
      formData.append('typeId', this.state.DataIntitucion.typeId)
      formData.append('nit', this.state.DataIntitucion.nit)
      formData.append('dv', this.state.DataIntitucion.dv)
      formData.append('name', this.state.form.nombre_edit)
      formData.append('name1', this.state.form.nombre1_edit)
      formData.append('name2', this.state.form.nombre2_edit)
      formData.append('lastname1', this.state.form.apell1_edit)
      formData.append('lastname2', this.state.form.apell2_edit)
      formData.append('Password', null)
      formData.append('providerCode', this.state.form.codigoprestador_edit)
      formData.append('email', this.state.DataIntitucion.email)  
      formData.append('web', this.state.form.web_edit)      
      formData.append('address', this.state.form.dir_edit)
      formData.append('phone1', this.state.form.tel1_edit)
      formData.append('phone2', this.state.form.tel2_edit)
      formData.append('departmentId', iddepa_edit)
      formData.append('municipalityId', idmuni_edit)
      formData.append('ProviderClass', claseprestador_edit)
      formData.append('LegalNature', naturaleza_edit)
      formData.append('Ese', ese_edit)
      formData.append('AtentionLevel', nivelatencion_edit)
      formData.append('TipeIdRepresentative', tipoidrl_edit)
      formData.append('IdRepresentative', this.state.form.idrl_edit)
      formData.append('nameRepresentative1', this.state.form.nom1rl_edit)
      formData.append('nameRepresentative2', this.state.form.nom2rl_edit)
      formData.append('lastNameRepresentative1', this.state.form.apell1rl_edit)
      formData.append('lastNameRepresentative2', this.state.form.apell2rl_edit)
      formData.append('PublicKey', "")
      formData.append('PrivateKey', "")
      formData.append('EventsKey',"")
      formData.append('Secretkey',"")

      await axios.post(ApiURL+"/api/Institutions/Save", formData,{

        headers: {
          'Content-Type': 'multipart/form-data'            
        }

      })  
      .then(response=>{
        console.log(response.data)
        var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

        this.Datos_Institucion();
        $('#modal-infoinstotucion').modal('hide'); 
        
        
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: mensaje,
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      }
      //console.log(error.config);
    
    })

    }      

   }


   save_llavesWOMPI=async()=>{

   

    if(this.state.form.llave_priv==null || this.state.form.llave_publi==null || this.state.form.llave_eventos==null || this.state.form.llave_integridad==null ){

      store.addNotification({
        title: 'Atención',
        message: "Faltan datos de las llaves por ingresar",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })

    }else{
      
      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })

      await axios.put(ApiURL+"/api/Institutions/SaveKeysWompi", 

        {
          publicKey:this.state.form.llave_publi,         
          privateKey: this.state.form.llave_priv,
          eventsKey:this.state.form.llave_eventos,
          secretKey:this.state.form.llave_integridad      
        })

      .then(response=>{
        console.log(response.data)
        var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

        this.Datos_Institucion();
        $('#modal-llaveswompi').modal('hide'); 
        
        
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: mensaje,
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      }
      //console.log(error.config);
    
    })

    }      

   }

   long_polling=async()=>{

    if(metodo_pago==='CARD'){

        axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
        .then((response) => {

          if(response.status=='200'){
    
            console.log(response.data.data.status);
    
            url_pse=response.data.data.status
    
    
            store.addNotification({
              title: 'Muy bien',
              message: 'Su compra con tarjeta de crédito ha sido: '+url_pse,
              type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

            $('#modal-compramembresia').modal('hide');
            this.setState({ loading_recurso: this.state.loading_recurso = true })
            $('#modal-loader').modal('hide') // <- to hide modal proceso compre

            this.dropmodal_comprar_membresia();

            window.location.href="/detalle_compra?id="+url; 

    
    
          }else{
              this.long_polling();  
      
            } 
        
     
        })
        .catch((error) => {
          console.log(error.message);
          //console.log(error.response.data.data);

          if(error.response.status=='417'){

            url_pse=error.response.data.message
    
    
            store.addNotification({
              title: 'Atención',
              message: url_pse,
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

            $('#modal-compramembresia').modal('hide');
            this.setState({ loading_recurso: this.state.loading_recurso = true })
            $('#modal-loader').modal('hide') // <- to hide modal proceso compre

            this.dropmodal_comprar_membresia();

            window.location.href="/detalle_compra?id="+url;

          }else{

            this.long_polling()

          }
 
          
        })

    }else{
      
            if(metodo_pago==='PSE'){
      
              axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
              .then((response) => {
      
                if(response.status=='200' && response.data.data.payment_method.extra.async_payment_url!==null){
                  
          
                  console.log(response.data.data.payment_method.extra.async_payment_url);
          
                  url_pse=response.data.data.payment_method.extra.async_payment_url

                  this.setState({ loading_recurso: this.state.loading_recurso = true })
                  $('#modal-loader').modal('hide') // <- to hide modal proceso compre
          
          
                  window.location.href=url_pse;   
          
          
                }else{
                  this.long_polling();  
          
                }         
     
              })
              .catch((error) => {
                //console.log(error.message);
               
                console.log(error.response.data.data.payment_method);
                if(error.response.data.data.payment_method.extra.async_payment_url==null){

                this.long_polling();
      
                }else{
      
                  let msj_pse=error.response.data.message
      
                  url_pse=error.response.data.data.payment_method.extra.async_payment_url
          
                  store.addNotification({
                    title: 'Atención',
                    message: msj_pse,
                    type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
      
                  $('#modal-compramembresia').modal('hide');
                  this.setState({ loading_recurso: this.state.loading_recurso = true })
                  $('#modal-loader').modal('hide') // <- to hide modal proceso compre
      
                  this.dropmodal_comprar_membresia();
    
                  window.location.href=url_pse;
                  //window.location.href="http://app.medicall24.com.co/detalle_compra?id="+url;
                  //this.long_polling()
      
                }
      
              })

      }else{

          if(metodo_pago==='BANCOLOMBIA_TRANSFER'){
      
          axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
          .then((response) => {
  
            if(response.status=='200' && response.data.data.payment_method.extra.async_payment_url!==null){
      
              console.log(response.data.data.payment_method.extra.async_payment_url);
      
              url_pse=response.data.data.payment_method.extra.async_payment_url   
              
              this.setState({ loading_recurso: this.state.loading_recurso = true })
              $('#modal-loader').modal('hide') // <- to hide modal proceso compre
      
              window.location.href=url_pse;   
      
      
            }else{
              this.long_polling();  
      
            }         
 
          })
          .catch((error) => {
            //console.log(error.message);
            console.log(error.response.data.data.payment_method);
            if(error.response.data.data.payment_method.extra.async_payment_url==null){

              this.long_polling();
  
            }else{
  
              let msj_pse=error.response.data.message
      
              url_pse=error.response.data.data.payment_method.extra.async_payment_url
      
              store.addNotification({
                title: 'Atención',
                message: msj_pse,
                type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
  
              $('#modal-compramembresia').modal('hide');
              this.setState({ loading_recurso: this.state.loading_recurso = true })
              $('#modal-loader').modal('hide') // <- to hide modal proceso compre
  
              this.dropmodal_comprar_membresia();

              window.location.href=url_pse;
              //window.location.href="http://app.medicall24.com.co/detalle_compra?id="+url;
              //this.long_polling()
  
            }
  
          })

        }else{

          if(metodo_pago==='NEQUI'){
      
            axios.get(ApiURL+"/api/Payments/GetStatusOrder/"+url)
            .then((response) => {
    
              if(response.status=='200'){
        
                console.log(response.data.data.status);
    
                url_pse=response.data.data.status
        
        
                store.addNotification({
                  title: 'Muy bien',
                  message: 'Su compra con Nequi ha sido: '+url_pse,
                  type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                $('#modal-compramembresia').modal('hide');
                this.setState({ loading_recurso: this.state.loading_recurso = true })
                $('#modal-loader').modal('hide') // <- to hide modal proceso compre
    
                this.dropmodal_comprar_membresia(); 

                window.location.href="/detalle_compra?id="+url;
        
        
              }else{
                this.long_polling();  
        
              }         
   
            })
            .catch((error) => {
              console.log(error.message);
              
              if(error.response.status=='417'){

                url_pse=error.response.data.message
        
        
                store.addNotification({
                  title: 'Atención',
                  message: url_pse,
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
    
                $('#modal-compramembresia').modal('hide');
                this.setState({ loading_recurso: this.state.loading_recurso = true })
                $('#modal-loader').modal('hide') // <- to hide modal proceso compre
    
                this.dropmodal_comprar_membresia();

                window.location.href="/detalle_compra?id="+url;
    
              }else{
    
                this.long_polling()
    
              }
    
            })
  
          }

        }


      }

    }

    

   }

   detalle_compraXmetodo(){      
      
    this.setState({ loading_button: this.state.loading_button = false })
    this.setState({ active_button: this.state.active_button = false })

    axios.post(ApiURL+"/api/Payments/GetDetailPayment",
    {
      productID: tipo_membresia,
      PaymentMethod: metodo_pago        
    })
    .then((response) => {
      console.log(response.data);
      
      this.setState({Detalle_compra: response.data}) 

    this.setState({ loading_button: this.state.loading_button = true })
    this.setState({ active_button: this.state.active_button = true })

      $('#compra_paso2').hide();
      $('#compra_paso3').show();

      $('#btn_compra_paso2').hide();
      $('#btn_compra_paso3').show();


    })
    .catch((error) => {
      console.log(error);

      this.setState({ loading_button: this.state.loading_button = true })
      this.setState({ active_button: this.state.active_button = true })
    })
    

  }


  Validar_formularios_compra(){

          if(this.state.form.tipoid_comprador_general=='null' || this.state.form.id_comprador_general.length==0 || this.state.form.nombres_comprador_general.length==0 || this.state.form.apellidos_comprador_general.length==0 || this.state.form.dir_comprador_general.length==0 || this.state.form.tel_comprador_general.length==0){
      
            store.addNotification({
              title: 'Atención',
              message: "Faltan datos del comprador por ingresar",
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })
          
          }else{
            if(metodo_pago===''){
              store.addNotification({
                title: 'Atención',
                message: "Seleccione un método de pago",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
            }
          }
          if(metodo_pago==='CARD'){
      
            if(this.state.form.num_tc.length==0 || this.state.form.tarjetahabiente.length==0 || this.state.form.mes_tc==='MM' || this.state.form.year_tc==='YY' || this.state.form.cuotas_tc==='0' || this.state.form.cod_tc.length==0){

              store.addNotification({
                title: 'Atención',
                message: "Faltan datos de la tarjeta por ingresar",
                type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                container: 'top-right',                // where to position the notifications
                animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                dismiss: {
                  duration: 10000,
                  showIcon:true
                }
              })
      
            }else{
              this.detalle_compraXmetodo();
            }
      
          }else{

            if(metodo_pago==='PSE'){

              if(tipo_persona==='' || this.state.form.id_banco_pse.length==0 ){

                store.addNotification({
                  title: 'Atención',
                  message: "Faltan datos de PSE por ingresar",
                  type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                  container: 'top-right',                // where to position the notifications
                  animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                  animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                  dismiss: {
                    duration: 10000,
                    showIcon:true
                  }
                })
        
              }else{
                this.detalle_compraXmetodo();
              }              

            }else{

              if(metodo_pago==='NEQUI'){

                if( this.state.form.cel_nequi.length==0 ){

                  store.addNotification({
                    title: 'Atención',
                    message: "Faltan datos de Nequi por ingresar",
                    type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                    container: 'top-right',                // where to position the notifications
                    animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                    animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                    dismiss: {
                      duration: 10000,
                      showIcon:true
                    }
                  })
          
                }else{
                  this.detalle_compraXmetodo();
                }

              }else{
                if(metodo_pago==='BANCOLOMBIA_TRANSFER'){

                  if( tipo_persona==='' ){

                    store.addNotification({
                      title: 'Atención',
                      message: "Faltan datos de bancolombia por ingresar",
                      type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
                      container: 'top-right',                // where to position the notifications
                      animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
                      animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
                      dismiss: {
                        duration: 10000,
                        showIcon:true
                      }
                    })
            
                  }else{
                    this.detalle_compraXmetodo();
                  }

                }
              }
            }
            
          }

   }

   

   ComprarMembresia=async()=>{


    this.setState({ loading_button: this.state.loading_button = false })
    this.setState({ active_button: this.state.active_button = false })

    await axios.post(ApiURL+"/api/Payments/Membership",  
    {
      typeId: this.state.form.tipoid_comprador_general,
      identification: this.state.form.id_comprador_general,
      names: this.state.form.nombres_comprador_general,
      lastNames: this.state.form.apellidos_comprador_general,
      email: this.state.DataIntitucion.email,
      address: this.state.form.dir_comprador_general,
      phone: this.state.form.tel_comprador_general,
      institutionId: institution_id,
      membershipId: tipo_membresia,
      paymentMethod: {
        type: metodo_pago,
        installments: this.state.form.cuotas_tc,
        card: {
          number: this.state.form.num_tc,
          cvc: this.state.form.cod_tc,
          expMonth: this.state.form.mes_tc,
          expYear: this.state.form.year_tc,
          cardHolder: this.state.form.tarjetahabiente
        },
        userType: tipo_persona,
        paymentDescription: "Compra Membresia",
        phoneNumber: this.state.form.cel_nequi,
        userLegalIdType: this.state.form.tipoid_comprador_general,
        userLegalId: this.state.form.id_comprador_general,
        financialInstitutionCode: this.state.form.id_banco_pse
      }
    } )          

    .then(response=>{
      console.log(response.data)
      mensaje  = response.data.message;
      url  = response.data.data.transactionId;
      //alert(url);
      //const [text, setText] = LocalStorage(text, '')
      console.log(url)     
      
      if(mensaje=='No fué posible generar la transacción.'){

        store.addNotification({
          title: 'Atención',
          message: mensaje,
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })

      }else{

        store.addNotification({
          title: 'Atención',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

        //window.location.href=url;
      //window.open(url)
      $('#modal-compramembresia').modal('hide');
      this.setState({ loading_recurso: this.state.loading_recurso = false })
      $('#modal-loader').modal('show') // <- to show modal descarga video

      this.setState({ loading_button: this.state.loading_button = true })
      this.setState({ active_button: this.state.active_button = true })

      this.long_polling()

      }             
      
      
      
    })
    .catch(error=>{
     
      if (error.response) {
        /*
         * The request was made and the server responded with a
         * status code that falls out of the range of 2xx
         */
        //console.log(error.response.data.message);
        //console.log(error.response.status);
        //console.log(error.response.headers);
        mensaje=error.response.data.message
        
        store.addNotification({
          title: 'Atención',
          message: mensaje,
          type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
            duration: 10000,
            showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true })
        this.setState({ loading_recurso: this.state.loading_recurso = false })

    } else if (error.request) {
        /*
         * The request was made but no response was received, `error.request`
         * is an instance of XMLHttpRequest in the browser and an instance
         * of http.ClientRequest in Node.js
         */
        console.log(error.request);
    } else {
        // Something happened in setting up the request and triggered an Error
        console.log('Error', error.message);
    }
    //console.log(error.config);
  
  })


   }


   Activar_membresia=async()=>{

    if(this.state.form.cod_membresia1=='' || this.state.form.cod_membresia2=='' || this.state.form.cod_membresia3=='' || this.state.form.cod_membresia4=='' || this.state.form.cod_membresia5=='' ){

      store.addNotification({
        title: 'Atención',
        message: "Ingresa un código de membresía valido",
        type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
        container: 'top-right',                // where to position the notifications
        animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
        animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
        dismiss: {
          duration: 10000,
          showIcon:true
        }
      })

    }else{
      
      
      this.setState({ loading_button: this.state.loading_button = false })
      this.setState({ active_button: this.state.active_button = false })    

      await axios.put(ApiURL+"/api/Memberships/AddToInstitution", 

        {           
          membershipCode: this.state.form.cod_membresia1+"-"+this.state.form.cod_membresia2+"-"+this.state.form.cod_membresia3+"-"+this.state.form.cod_membresia4+"-"+this.state.form.cod_membresia5          
        })
 
      .then(response=>{
        console.log(response.data)
        var  mensaje  = response.data.message;
        //alert(mensaje);
        //const [text, setText] = LocalStorage(text, '')
        //setText(dato);
               
        //window.location.href="/home";
      store.addNotification({
          title: 'Muy bien',
          message: mensaje,
          type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
          container: 'top-right',                // where to position the notifications
          animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
          animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
          dismiss: {
          duration: 10000,
          showIcon:true
          }
        })

        this.setState({ loading_button: this.state.loading_button = true })
        this.setState({ active_button: this.state.active_button = true }) 

        $('#modal-activarmembresia').modal('hide');

        //$('#alert-recoverypass').html('<div class="alert alert-success" role="alert">'+mensaje+'</div>');
  
      })
      .catch(error=>{
       
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          //console.log(error.response.data.message);
          //console.log(error.response.status);
          //console.log(error.response.headers);
          mensaje=error.response.data.message
          
          store.addNotification({
            title: 'Atención',
            message: mensaje,
            type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })

          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })

        //$('#alert-recoverypass').html('<div class="alert alert-danger" role="alert">'+mensaje+'</div>');

      } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          console.log(error.request);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      } else {
          // Something happened in setting up the request and triggered an Error
          console.log('Error', error.message);
          this.setState({ loading_button: this.state.loading_button = true })
          this.setState({ active_button: this.state.active_button = true })
      }
      //console.log(error.config);
    
    })
    

    }      

   }


    render(){  
      const {form} = this.state;

     return (

     
      <div className="content-wrapper">

            <div className="col-12 col-sm-12">

                  <div className="row">
              
                          <div className="col-sm-12">      
                          <br></br>
                             <div className="text-center" id="title"> <h6> <b> PERFIL DEL PRESTADOR </b>  </h6> </div>      
                          </div>
                
                         
                  </div>

                  <div className="card card-primary card-outline card-tabs">

                          <div className="card-header p-0 pt-1 border-bottom-0">
                               <ul className="nav nav-tabs" id="custom-tabs-three-tab" role="tablist">
                                  <li className="nav-item">
                                    <a className="nav-link active" id="custom-tabs-three-home-tab" data-toggle="pill" href="#custom-tabs-three-home" role="tab" aria-controls="custom-tabs-three-home" aria-selected="true" > Perfil  </a>
                                  </li>
                                  <li className="nav-item">
                                    <a className="nav-link" id="custom-tabs-three-profile-tab" data-toggle="pill" href="#custom-tabs-three-profile" role="tab" aria-controls="custom-tabs-three-profile" aria-selected="false" onClick={()=>{this.Cargar_membresias()}} > Membresía </a>
                                  </li>                                      
                              </ul>
                            
                          </div>

                          <div className="card-body" /*id="tabla_publicaciones"*/>

                              <div className="tab-content" id="custom-tabs-three-tabContent">
                                
                                    <div className="tab-pane fade show active" id="custom-tabs-three-home" role="tabpanel" aria-labelledby="custom-tabs-three-home-tab">      

                                          <div id="perfil_cover" className="row">

                                              <img id="portada" src={this.state.DataIntitucion.cover} className="card-img-top" />                         
                                            
                                              <div id="file_portada" className="custom-file">
                                                  <input type="file" name="selectedFilep" id="exampleInputFilep" className="inputfile inputfile-6" accept="image/jpg,image/jpeg,image/bmp,image/png" onChange={this.GetImg_portada}/>
                                                
                                                  <label htmlFor="file-6" for="exampleInputFilep">
                                                    <figure>
                                                    <img src={iconofotoportada} width="40"/>
                                                    </figure>
                                                    {/*<span className="iborrainputfile">{num_file}</span>*/}
                                                  </label>
                                              </div>
                                            
                                          </div> 

                                          <div id="perfil_avatar" className="row">

                                              <img id="avatar" src={this.state.DataIntitucion.avatar} className="rounded-circle" />                         
                                              
                                              <div id="file_avatar" className="custom-file">
                                                  <input type="file" name="selectedFile" id="exampleInputFile" className="inputfile inputfile-6" accept="image/jpg,image/jpeg,image/bmp " onChange={this.GetImg}/>
                                                
                                                  <label htmlFor="file-6" for="exampleInputFile">
                                                    <figure>
                                                    <img src={iconofotoavatar} width="40"/>
                                                    </figure>
                                                    {/*<span className="iborrainputfile">{num_file}</span>*/}
                                                  </label>
                                              </div>
                                          </div> 

                                          <div className="row">
                                            <div className="col-md-12 text-center">
                                            <br></br>                                            
                                               <h5>{this.state.DataIntitucion.name}</h5> 
                                            </div> 
                                            <div className="col-md-12 text-center">                                            
                                               <h6 id="nit_cod">{this.state.DataIntitucion.typeId +': '}{this.state.DataIntitucion.nit +'-'+ this.state.DataIntitucion.dv +' / Código prestador: '}{this.state.DataIntitucion.providerCode}</h6> 
                                            </div>
                                          </div>  

                                          <hr id="linea"></hr>   

                                          <div id="info_institucion" className="row justify-content-md-center">                                          
                                                          
                                              <div className="col col-lg-4">

                                                  <div className="form-group">                    
                                                          <div className="input-group">                          
                                                              <div className="input-group-append">
                                                                <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="6.7734mm" height="5.9083mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 52.01 45.37" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                  <defs>
                                                                    <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                  </defs>
                                                                  <g id="Capa_x0020_1">
                                                                    <metadata id="CorelCorpID_0Corel-Layer" />
                                                                    <path className="fil0" d="M26.41 29.89c0,3.74 -0.02,7.48 -0.01,11.22 0.01,4.7 2.98,4.26 7.27,4.08 0,-2.51 0,-5.03 0,-7.54 -0,-3.7 -0.74,-4.53 3.07,-4.53 3.88,0 3.07,0.93 3.1,4.53 0.02,2.5 0.02,5.01 -0.01,7.51 4.07,0.49 7.26,0.41 7.28,-3.85 0.02,-3.81 -0.01,-7.63 -0,-11.45 0.89,0.52 1.7,1.46 3.02,1.28 1.01,-0.14 3.79,-2.01 -0.21,-4.84l-10.26 -7.43c-0.64,-0.49 -1.84,-1.56 -2.91,-1.56 -1.26,0.01 -9,5.97 -10.43,7.06 -0.86,0.65 -1.57,1.14 -2.47,1.8 -0.76,0.56 -1.96,1.06 -2.23,2.24 -0.32,1.4 0.53,2.44 1.57,2.69 1.61,0.38 2.18,-0.75 3.22,-1.21zm-10.86 -29.75c-4.41,0.78 -8.2,5.03 -7.19,10.42 0.8,4.28 5.05,8.05 10.41,7.05 4.3,-0.8 8,-4.98 7.07,-10.33 -0.75,-4.3 -5.02,-8.08 -10.28,-7.15zm9.19 36.05l0.05 -3.49c-3.98,0.48 -6.21,-3.07 -4.21,-5.92 0.89,-1.26 5.08,-3.77 6.21,-4.77 0.28,-0.25 0.25,-0.24 0.39,-0.42 -1.14,-1.1 -4.36,-2.28 -6.28,-2.66 -9.79,-1.97 -19.38,4.78 -20.83,14.79 -0.46,3.19 1.15,2.47 6.38,2.47 6.1,0 12.19,0 18.29,0z" />
                                                                  </g>
                                                                </svg>
    
                                                              </div>                         
                                                              <p id="info_institucion"> &nbsp; &nbsp; &nbsp; {this.state.claseprestado}</p>                              
                                                          </div>                   
                                                  </div>

                                                  <div className="form-group">                    
                                                      <div className="input-group">                          
                                                          <div className="input-group-append">
                                                            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="6.2598mm" height="6.7732mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 33.54 53.33" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                              <defs>
                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                              </defs>
                                                              <g id="Capa_x0020_1">
                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                <g id="_2147849447472">
                                                                  <path className="fil0" d="M16.75 45.39c0.91,-0.6 7.66,-9.26 8.69,-10.69 2.42,-3.36 5.68,-8.12 7.19,-12.67 3.85,-11.63 -5.21,-22.03 -15.89,-22.02 -10.6,0.01 -19.7,10.47 -15.85,22 2.43,7.3 8.81,14.93 13.55,20.72 0.59,0.72 1.64,2.14 2.3,2.67zm-1.64 -36.83c-10.78,2.29 -7.55,18.55 3.42,16.33 4.03,-0.81 7.48,-4.81 6.41,-9.96 -0.83,-4 -4.86,-7.43 -9.83,-6.37z" />
                                                                  <path className="fil0" d="M21.93 42.66c1.21,1.04 2.7,0.82 3.22,2.88 -0.08,4.12 -14.43,4.41 -16.4,0.93 -0.56,-0.98 -0.23,-1.84 0.41,-2.42l1.89 -1c0.68,-0.39 0.3,-0.14 0.57,-0.39 -0.97,-1.42 -0.98,-1.23 -3.17,-0.62 -12.95,3.6 -6.45,11.28 8.3,11.29 13.65,0 19.59,-6.28 12.08,-9.93 -1.06,-0.52 -2.25,-0.94 -3.51,-1.31 -2.34,-0.67 -2.29,-0.86 -3.39,0.57z" />
                                                                </g>
                                                              </g>
                                                            </svg>

                                                          </div>                         
                                                          <p id="info_institucion"> &nbsp; &nbsp; &nbsp; {this.state.DataIntitucion.address +' / '+ muni +' - '+ depa }</p>                              
                                                      </div>                   
                                                  </div>

                                                  <div className="form-group">                    
                                                      <div className="input-group">                          
                                                          <div className="input-group-append">
                                                            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="25" height="25" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 52.01 52.01" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                              <defs>
                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                              </defs>
                                                              <g id="Capa_x0020_1">
                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                <path className="fil0" d="M19.82 10.41c-1.66,0.67 -3.09,2.21 -3.98,3.61 -1.12,1.77 -1.66,3.6 -1.45,6.21 0.49,6.06 6.71,16.3 11.16,19.54 1.45,1.05 3.39,1.98 5.74,1.99 2.11,0.01 4.78,-0.69 5.91,-1.83 0.89,-0.89 0.37,-1.82 -0.18,-2.63 -1.27,-1.87 -1.9,-2.68 -3.33,-4.35 -0.6,-0.7 -1.33,-1.46 -2.49,-0.58 -1.83,1.39 -2.25,3.3 -4.47,0.83 -2.28,-2.53 -4.56,-6.2 -5.76,-9.58 -1.3,-3.64 -0.64,-3.18 2.31,-4.2 2.13,-0.74 1.32,-2.38 0.13,-5.2 -0.96,-2.26 -1.66,-4.57 -3.58,-3.8zm6.18 -10.41c14.36,0 26,11.64 26,26.01 0,14.36 -11.64,26 -26,26 -14.36,0 -26.01,-11.64 -26.01,-26 0,-14.36 11.64,-26.01 26.01,-26.01zm0 3.73c12.3,0 22.27,9.97 22.27,22.27 0,12.3 -9.97,22.27 -22.27,22.27 -12.3,0 -22.27,-9.97 -22.27,-22.27 0,-12.3 9.97,-22.27 22.27,-22.27z" />
                                                              </g>
                                                            </svg>

                                                          </div>                         
                                                          <p id="info_institucion"> &nbsp; &nbsp; &nbsp; {'+57 '+this.state.DataIntitucion.phone1}</p>                              
                                                      </div>                   
                                                  </div>

                                                  

                                                  <div className="form-group">                    
                                                      <div className="input-group">                          
                                                          <div className="input-group-append">
                                                            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="6.7733mm" height="6.7663mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 88.93 62.58" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                              <defs>
                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                              </defs>
                                                              <g id="Capa_x0020_1">
                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                <path className="fil0" d="M7.22 62.58c-7.12,0 -0.12,-7.22 -0.12,-7.22l18.15 -19.94c1.76,-1.94 5.17,-4.88 7.16,-3.26 1.99,1.62 4.65,4.91 6.5,6.77l3.75 3.76c2.01,1.78 3.56,0 3.56,0l3.84 -3.78c1.87,-1.84 4.54,-5.05 6.54,-6.55 1.99,-1.49 5.39,1.35 7.15,3.29l18.04 19.93c7.12,7 0.12,7 0.12,7l-74.68 0 0 0zm3.08 -16.41c-1.76,1.94 -4.34,5.31 -6.08,7.27 -1.97,2.21 -4.22,3.89 -4.22,0.02l0.09 -38.91c0.01,-2.62 -0.07,-7.62 1.73,-6.73 0.67,0.33 1.58,1.03 2.82,2.27l14.68 12.01c2.03,1.66 4.89,3.69 5.82,5.05 0.59,0.85 0.86,1.85 0.01,2.7l-14.84 16.31zm39.58 -13.82c-2.03,1.66 -4.23,4.02 -5.36,4.03 -1.13,0 -3.37,-2.31 -5.41,-3.96l-31.95 -25.92c-2.04,-1.65 -5.55,-4.97 -3.8,-5.87 1.26,-0.64 3.46,-0.63 3.46,-0.63l75.08 0c6.76,0 3.32,3.34 3.32,3.34l-35.35 29.01zm34.83 21.1c-1.75,-1.96 -4.33,-5.33 -6.09,-7.27l-14.83 -16.31c-0.86,-0.86 -0.59,-1.85 0,-2.7 0.94,-1.35 3.8,-3.38 5.83,-5.04l11.01 -9.01c2.03,-1.66 4.7,-4.38 6.49,-5.27 1.79,-0.9 1.71,4.11 1.72,6.73l0.09 38.91c0,3.87 -2.25,2.19 -4.22,-0.02z" />
                                                              </g>
                                                            </svg>

                                                          </div>                         
                                                          <p id="info_institucion"> &nbsp; &nbsp; &nbsp; {this.state.DataIntitucion.email}</p>                              
                                                      </div>                   
                                                  </div>
                                                      
                                              </div>

                                             

                                              <div className="col-md-4" id="hr_vertical">
                                                                                                  

                                                  <div className="form-group offset-md-1">                    
                                                      <div className="input-group">                          
                                                          <div className="input-group-append">
                                                             <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="6.2292mm" height="6.7732mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 44.26 48.13" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                              <defs>
                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                              </defs>
                                                              <g id="Capa_x0020_1">
                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                <path className="fil0" d="M38.73 36.09l5.53 12.03 -44.26 0 5.53 -12.03 33.2 0zm-16.6 -36.09l6.82 14.82 -13.63 0 6.82 -14.82zm7.77 16.89l3.47 7.54 -22.46 0 3.47 -7.54 15.53 0zm4.42 9.6l3.47 7.54 -31.3 0 3.47 -7.54 24.36 0z" />
                                                              </g>
                                                            </svg>

                                                          </div>                         
                                                          <p id="info_institucion"> &nbsp; &nbsp; &nbsp; {this.state.nivelatencion}</p>                              
                                                      </div>                   
                                                  </div>                                     
                                                  
                                                  <div className="form-group offset-md-1">  

                                                      <div className="input-group">                          
                                                          <div className="input-group-append">
                                                              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#AD1457" className="bi bi-key-fill" viewBox="0 -1 16 16">
                                                                    <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                                              </svg>                                                                      
        
                                                          </div> 
                                                          <a id="btn-llaveswompi" className="btn" onClick={()=> this.modal_llavesWOMPI()}>  Llaves de autenticación de WOMPI </a>                        
                                                                                      
                                                      </div> 

                                                  </div>
                                                  
                                                  <div className="form-group offset-md-1">                    
                                                      <div className="input-group">                          
                                                          <div className="input-group-append">
                                                            <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="6.7735mm" height="6.7734mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 88.94 88.94" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                              <defs>
                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                              </defs>
                                                              <g id="Capa_x0020_1">
                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                <path className="fil0" d="M44.47 0c-24.53,0 -44.47,19.94 -44.47,44.47 0,24.53 19.94,44.47 44.47,44.47 2.78,0 5.49,-0.26 8.15,-0.74l-3.04 -9.12c-0.45,0.45 -0.93,0.82 -1.41,1.15l0 -5.41 -6.89 -20.64c-0.37,-1.08 -0.52,-2.19 -0.52,-3.26l0 7.52c-3.52,0.15 -6.97,0.45 -10.23,1 -0.67,-3.48 -1.11,-7.26 -1.3,-11.34l11.53 0 0 2.82c0,-2.63 1.03,-5.19 3,-7.15 1.89,-1.93 4.45,-3 7.19,-3 1.11,0 2.19,0.19 3.26,0.52l20.42 6.82 6.71 0c-0.07,0.74 -0.15,1.44 -0.3,2.15l7.15 2.37c0.48,-2.67 0.74,-5.37 0.74,-8.15 0,-24.53 -19.94,-44.47 -44.47,-44.47zm18.22 88.94c-0.02,0 -0.04,0 -0.06,0 -1.17,-0.03 -2.2,-0.78 -2.57,-1.9l-11.73 -35.2c-0.33,-1 -0.08,-2.1 0.67,-2.85 0.74,-0.75 1.85,-1.01 2.85,-0.67l35.2 11.74c1.11,0.37 1.87,1.4 1.9,2.57 0.03,1.17 -0.68,2.24 -1.78,2.66l-15.8 6.08 -6.08 15.8c-0.41,1.08 -1.45,1.78 -2.59,1.78l0 0zm-21.92 -23.08l0 14.38c-3.19,-2.15 -6.23,-6.89 -8.37,-13.6 2.7,-0.41 5.48,-0.67 8.37,-0.78zm-27.42 -41.43c2.96,1.41 6.3,2.6 9.93,3.56 -0.78,3.97 -1.26,8.23 -1.45,12.71l-14.23 0c0.59,-5.93 2.67,-11.45 5.74,-16.27zm-5.74 23.68l14.23 0c0.19,4.56 0.67,8.86 1.45,12.86 -3.63,0.97 -6.97,2.15 -9.93,3.56 -3.11,-4.82 -5.15,-10.41 -5.74,-16.42l0 0zm21.83 30.2c-4.26,-1.89 -8.08,-4.56 -11.3,-7.82 2.11,-0.93 4.45,-1.7 6.93,-2.33 1.18,3.82 2.67,7.26 4.37,10.15l0 0zm-4.37 -57.51c-2.48,-0.63 -4.82,-1.41 -6.93,-2.33 3.22,-3.26 7.04,-5.93 11.3,-7.82 -1.7,2.89 -3.19,6.34 -4.37,10.15l0 0zm15.71 19.9l-11.53 0c0.19,-4 0.63,-7.75 1.3,-11.19 3.26,0.56 6.71,0.85 10.23,1l0 10.19zm0 -17.6c-2.89,-0.11 -5.67,-0.37 -8.37,-0.78 2.15,-6.71 5.19,-11.45 8.37,-13.6l0 14.38zm7.41 -14.38c3.19,2.15 6.23,6.89 8.38,13.6 -2.71,0.41 -5.49,0.67 -8.38,0.78l0 -14.38zm0 31.98l0 -10.19c3.52,-0.15 6.97,-0.44 10.23,-1 0.67,3.44 1.11,7.19 1.3,11.19l-11.53 0zm11.34 -30.05c4.26,1.89 8.08,4.56 11.3,7.82 -2.11,0.93 -4.45,1.7 -6.93,2.33 -1.19,-3.81 -2.67,-7.26 -4.37,-10.15l0 0zm7.6 30.05c-0.19,-4.48 -0.67,-8.74 -1.45,-12.71 3.63,-0.96 6.97,-2.15 9.93,-3.56 3.08,4.82 5.15,10.34 5.74,16.27l-14.23 0z" />
                                                              </g>
                                                            </svg>

                                                          </div>                         
                                                           
                                                          <a  href={this.state.DataIntitucion.web} target="_blank"><p id="web"> &nbsp; &nbsp; &nbsp;   {this.state.DataIntitucion.web ? this.state.DataIntitucion.web : '' }</p> </a>    
                                                          <div className="input-group-append">
                                                        
                                                                <svg type="button" onClick={()=> this.handleModaleditinfo()} xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="21.00mm" height="12.35mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 25.2 25.2" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                  <defs>
                                                                    <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n    .fil1 {fill:white}\n   \n  " }} />
                                                                  </defs>
                                                                  <g id="Capa_x0020_1">
                                                                    <metadata id="CorelCorpID_0Corel-Layer" />
                                                                    <g id="_2129058471408">
                                                                      <circle className="fil0" cx="11.6" cy="11.6" r="11.6" />
                                                                      <path className="fil1" d="M5.84 15.01l0 2.44 2.44 0 7.19 -7.19 -2.44 -2.44 -7.19 7.19zm11.51 -6.64c0.25,-0.25 0.25,-0.66 0,-0.92l-1.52 -1.52c-0.25,-0.25 -0.66,-0.25 -0.92,0l-1.19 1.19 2.44 2.44 1.19 -1.19z" />
                                                                    </g>
                                                                  </g>

                                                                </svg>                                                         

                                                          </div>                                                                                                       
                                                                                  
                                                      </div>  

                                                  </div>
                                                                                                      
                                                      
                                              </div>                   
                                             
                                          </div>

                                          <br/> 

                                          {/* <div className="row justify-content-md-center">                                        
                                                          
                                              <div className="col col-lg-4">                                     

                                                  <div className="col-md-12 text-center">
                                                      <a id="btn-llaveswompi" className="btn" onClick={()=> this.modal_llavesWOMPI()}>
                                                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#AD1457" class="bi bi-key-fill" viewBox="0 0 16 16">
                                                            <path d="M3.5 11.5a3.5 3.5 0 1 1 3.163-5H14L15.5 8 14 9.5l-1-1-1 1-1-1-1 1-1-1-1 1H6.663a3.5 3.5 0 0 1-3.163 2zM2.5 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
                                                          </svg> Llaves de autenticación de WOMPI
                                                      </a> 
                                                  </div>
                                                          
                                              </div>                                                  
                                             
                                          </div>  */}

                                          {/* <Publicaciones/>            */}
                                      

                                    </div>

                                    <div className="tab-pane fade" id="custom-tabs-three-profile" role="tabpanel" aria-labelledby="custom-tabs-three-profile-tab">

                                          <div className="row">
                                              <div className="col-md-12">                                                                                  
                                                  <button id="btn_crear" className="btn btn-edit" onClick={()=>{this.modal_activamembresia()}}> Activar membresía
                                                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-patch-check" viewBox="-1 0 17 17">
                                                        <path fill-rule="evenodd" d="M10.354 6.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7 8.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
                                                        <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911l-1.318.016z"/>
                                                      </svg>
                                                  </button>
                                             </div> 
                                             
                                          </div>
                                          
                                          <div className="row">
                                              <div className="col-md-12 text-center">                                                                                  
                                                  <h4> <b>{(this.state.DataMembresia.name)}</b></h4> 
                                                  <br></br>
                                             </div> 
                                             
                                          </div>

                                          <div className="row justify-content-md-center">                                          
                                                          
                                              <div className="col col-lg-4">

                                                  <div className="form-group">                                                                                                 
                                                      <p id="espacios" >Estado:</p>                                                                                 
                                                      <p id="info">{this.state.DataMembresia.status}</p>                                                           
                                                  </div>

                                                  <div className="form-group">                                                               
                                                      <p id="espacios">Código de membresía:</p>                       
                                                      <p id="info"> {this.state.DataMembresia.code}</p>                                                            
                                                  </div>

                                                      
                                              </div>                                             

                                              <div className="col-md-4" id="hr_vertical"> 

                                                  <div className="form-group offset-md-2">                                               
                                                      <p id="espacios" >Fencha final:</p>                                                          
                                                      <p id="info">{moment(this.state.DataMembresia.startDate).format("DD/MM/YYYY")}</p>                                                               
                                                  </div>

                                                  <div className="form-group offset-md-2">                                                                                                    
                                                       <p id="espacios" >Fencha final:</p>                                                                       
                                                      <p id="info"> {moment(this.state.DataMembresia.endDate).format("DD/MM/YYYY")}</p>                              
                                                                         
                                                  </div>                                                                                      
                                                      
                                              </div>                   
                                             
                                          </div>

                                          <div className="row" id="actualiza_plan">
                                              <div className="col-md-12 text-center"> 
                                                  <br></br>                                                                                 
                                                  <h6> <b id="act_plan">Actualizar Membresía</b> </h6> 
                                             </div> 
                                             
                                          </div>  

                                          <div id="institucion">

                                          <div id="platinium">

                                          <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
                                              <div className="carousel-inner">
                                                <div className="carousel-item active">

                                                    <div className="row">
                                                        <div className="col-md-3 offset-md-3">
                                                          <br></br>
                                                          <img src={platinium} width="150" />
                                                        </div>

                                                        <div className="col-md-6">                                                            
                                                            <br></br>
                                                            <h4 id="espacios"><b id="titulo_plan" >Membresía Platinium</b></h4>                                                             
                                                            <div className="input-group-append">                                                                   
                                                                <p id="texto">  para 12 meses</p>       
                                                            </div>                                                            
                                                                               
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg>  
                                                                    <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                </div>                                                     
                                                                                    
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                </div>
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Incluye 15.840 Minutos en videollamadas</p>         
                                                                </div> 
                                                                <div className="input-group-append">
                                                                    
                                                                  <h5><p id="espacios"> USD $791 / ANUAL</p></h5>           
                                                                </div> 

                                                                <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_platinum_institucion()} >
                                                                    Ver detalles
                                                                </a>

                                                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="2")}>
                                                                 COMPRAR
                                                                </button>
                                                                <br></br>                                                                                   
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="carousel-item">
                                                    <div className="row">
                                                        <div className="col-md-3 offset-md-3">
                                                         <br></br>
                                                         <img src={golden} width="150" />
                                                        </div>
                                                        
                                                        <div className="col-md-6">                                                            
                                                            <br></br>
                                                            <h4 id="espacios"><b id="titulo_plan" >Membresía Golden</b></h4>                                                             
                                                            <div className="input-group-append">                                                                   
                                                                <p id="texto"> para 12 meses</p>       
                                                            </div>                                                            
                                                                               
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg>  
                                                                    <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                </div>                                                     
                                                                                    
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                </div>
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Incluye 31.680 Minutos en videollamadas</p>         
                                                                </div> 
                                                                <div className="input-group-append">
                                                                    
                                                                  <h5><p id="espacios"> USD $1.087 / ANUAL</p></h5>           
                                                                </div> 

                                                                <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_golden_institucion()} >
                                                                    Ver detalles
                                                                </a>

                                                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                                                 COMPRAR
                                                                </button>
                                                                <br></br>                                                                                   
                                                        
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                                <div className="carousel-item">
                                                    <div className="row">
                                                        <div className="col-md-3 offset-md-3">
                                                          <br></br>
                                                          <img src={diamond} width="150" />
                                                        </div>
                                                        
                                                        <div className="col-md-6">                                                            
                                                            <br></br>
                                                            <h4 id="espacios"><b id="titulo_plan" >Membresía Diamond</b></h4>                                                             
                                                            <div className="input-group-append">                                                                   
                                                                <p id="texto"> para 12 meses</p>       
                                                            </div>                                                            
                                                                               
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg>  
                                                                    <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                </div>                                                     
                                                                                    
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                </div>
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Incluye 63.360 Minutos en videollamadas</p>         
                                                                </div> 
                                                                <div className="input-group-append">
                                                                    
                                                                  <h5><p id="espacios"> USD $1.384 / ANUAL</p></h5>           
                                                                </div> 

                                                                <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_diamond_institucion()} >
                                                                    Ver detalles
                                                                </a>

                                                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="4")}>
                                                                 COMPRAR
                                                                </button>
                                                                <br></br>                                                                                   
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                              </div>
                                              <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true" /> 
                                                <span className="sr-only">Previous</span>
                                              </a>
                                              <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true" />
                                                <span className="sr-only">Next</span>
                                              </a>
                                          </div>
                                            
                                              </div>  
    
                                              <div id="golden">

                                          <div id="carouselExampleControlsg" className="carousel slide" data-ride="carousel">
                                              <div className="carousel-inner">
                                                
                                                <div className="carousel-item active">
                                                    <div className="row">
                                                        <div className="col-md-3 offset-md-3">
                                                         <br></br>
                                                         <img src={golden} width="150" />
                                                        </div>
                                                        
                                                        <div className="col-md-6">                                                            
                                                            <br></br>
                                                            <h4 id="espacios"><b id="titulo_plan" >Membresía Golden</b></h4>                                                             
                                                            <div className="input-group-append">                                                                   
                                                                <p id="texto"> para 12 meses</p>       
                                                            </div>                                                            
                                                                               
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg>  
                                                                    <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                </div>                                                     
                                                                                    
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                </div>
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Incluye 31.680 Minutos en videollamadas</p>         
                                                                </div> 
                                                                <div className="input-group-append">
                                                                    
                                                                  <h5><p id="espacios"> USD $1.087 / ANUAL</p></h5>           
                                                                </div> 

                                                                <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_golden_institucion()} >
                                                                    Ver detalles
                                                                </a>

                                                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                                                 COMPRAR
                                                                </button>
                                                                <br></br>                                                                                   
                                                        
                                                        </div>
                                                    </div>
                                                   
                                                </div>
                                                <div className="carousel-item">
                                                    <div className="row">
                                                        <div className="col-md-3 offset-md-3">
                                                          <br></br>
                                                          <img src={diamond} width="150" />
                                                        </div>
                                                        
                                                        <div className="col-md-6">                                                            
                                                            <br></br>
                                                            <h4 id="espacios"><b id="titulo_plan" >Membresía Diamond</b></h4>                                                             
                                                            <div className="input-group-append">                                                                   
                                                                <p id="texto"> para 12 meses</p>       
                                                            </div>                                                            
                                                                               
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg>  
                                                                    <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                </div>                                                     
                                                                                    
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                </div>
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Incluye 63.360 Minutos en videollamadas</p>         
                                                                </div> 
                                                                <div className="input-group-append">
                                                                    
                                                                  <h5><p id="espacios"> USD $1.384 / ANUAL</p></h5>           
                                                                </div> 

                                                                <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_diamond_institucion()} >
                                                                    Ver detalles
                                                                </a>

                                                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="4")}>
                                                                 COMPRAR
                                                                </button>
                                                                <br></br>                                                                                   
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                              </div>
                                              <a className="carousel-control-prev" href="#carouselExampleControlsg" role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true" /> 
                                                <span className="sr-only">Previous</span>
                                              </a>
                                              <a className="carousel-control-next" href="#carouselExampleControlsg" role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true" />
                                                <span className="sr-only">Next</span>
                                              </a>
                                          </div>
                                            
                                              </div> 
    
                                              <div id="diamond">

                                          <div id="carouselExampleControlsd" className="carousel slide" data-ride="carousel">
                                              <div className="carousel-inner">                                               
                                                
                                                <div className="carousel-item active">
                                                    <div className="row">
                                                        <div className="col-md-3 offset-md-3">
                                                          <br></br>
                                                          <img src={diamond} width="150" />
                                                        </div>
                                                        
                                                        <div className="col-md-6">                                                            
                                                            <br></br>
                                                            <h4 id="espacios"><b id="titulo_plan" >Membresía Diamond</b></h4>                                                             
                                                            <div className="input-group-append">                                                                   
                                                                <p id="texto"> para 12 meses</p>       
                                                            </div>                                                            
                                                                               
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg>  
                                                                    <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                </div>                                                     
                                                                                    
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                </div>
                                                                <div className="input-group-append">
                                                                   <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                      <defs>
                                                                        <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                      </defs>
                                                                      <g id="Capa_x0020_1">
                                                                        <metadata id="CorelCorpID_0Corel-Layer" />
                                                                        <g id="_1482714532112">
                                                                          <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                          <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                        </g>
                                                                      </g>
                                                                    </svg> 
                                                                    <p id="espacios"> &nbsp; Incluye 63.360 Minutos en videollamadas</p>         
                                                                </div> 
                                                                <div className="input-group-append">
                                                                    
                                                                  <h5><p id="espacios"> USD $1.384 / ANUAL</p></h5>           
                                                                </div> 

                                                                <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_diamond_institucion()} >
                                                                    Ver detalles
                                                                </a>

                                                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="4")}>
                                                                 COMPRAR
                                                                </button>
                                                                <br></br>                                                                                   
                                                        
                                                        </div>
                                                    </div>
                                                </div>
                                              </div>
                                              <a className="carousel-control-prev" href="#carouselExampleControlsd" role="button" data-slide="prev">
                                                <span className="carousel-control-prev-icon" aria-hidden="true" /> 
                                                <span className="sr-only">Previous</span>
                                              </a>
                                              <a className="carousel-control-next" href="#carouselExampleControlsd" role="button" data-slide="next">
                                                <span className="carousel-control-next-icon" aria-hidden="true" />
                                                <span className="sr-only">Next</span>
                                              </a>
                                          </div>
                                            
                                              </div>                                                                                        
                                         
                                          </div>

                                          <div id="independiente">

                                              <div id="platinium_in">

                                                  <div id="carouselExampleControls_in" className="carousel slide" data-ride="carousel">
                                                      <div className="carousel-inner">
                                                        <div className="carousel-item active">
        
                                                            <div className="row">
                                                                <div className="col-md-3 offset-md-3">
                                                                  <br></br>
                                                                  <img src={silver} width="150" />
                                                                </div>
        
                                                                <div className="col-md-6">                                                            
                                                                    <br></br>
                                                                    <h4 id="espacios"><b id="titulo_plan" >Membresía Silver</b></h4>                                                             
                                                                    <div className="input-group-append">                                                                   
                                                                        <p id="texto">  para 12 meses</p>       
                                                                    </div>                                                            
                                                                                       
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg>  
                                                                            <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                        </div>                                                     
                                                                                            
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg> 
                                                                            <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                        </div>
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg> 
                                                                            <p id="espacios"> &nbsp; Incluye 7.920 Minutos en videollamadas</p>         
                                                                        </div> 
                                                                        <div className="input-group-append">
                                                                            
                                                                        <h5><p id="espacios"> USD $395 / ANUAL</p></h5>           
                                                                        </div>                                                                       

                                                                        <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_silver_independiente()} >
                                                                            Ver detalles
                                                                        </a>
                                                                                                                                          

                                                                        <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="2")}>
                                                                         COMPRAR
                                                                        </button>
                                                                        <br></br>                                                                                   
                                                                
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="carousel-item">
                                                            <div className="row">
                                                                <div className="col-md-3 offset-md-3">
                                                                 <br></br>
                                                                 <img src={golden} width="150" />
                                                                </div>
                                                                
                                                                <div className="col-md-6">                                                            
                                                                    <br></br>
                                                                    <h4 id="espacios"><b id="titulo_plan" >Membresía Golden</b></h4>                                                             
                                                                    <div className="input-group-append">                                                                   
                                                                        <p id="texto"> para 12 meses</p>       
                                                                    </div>                                                            
                                                                                       
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg>  
                                                                            <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                        </div>                                                     
                                                                                            
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg> 
                                                                            <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                        </div>
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg> 
                                                                            <p id="espacios"> &nbsp; Incluye 15.840 Minutos en videollamadas</p>         
                                                                        </div> 
                                                                        <div className="input-group-append">
                                                                            
                                                                          <h5><p id="espacios"> USD $544 / ANUAL</p></h5>           
                                                                        </div>

                                                                        <a id="btn-verdetalle" className="btn" onClick={()=> this.modal_detalle_golden_independiente()} >
                                                                            Ver detalles
                                                                        </a>

                                                                        <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                                                         COMPRAR
                                                                        </button>
                                                                        <br></br>                                                                                   
                                                                
                                                                </div>
                                                            </div>
                                                           
                                                        </div>
                                                        
                                                      </div>
                                                      <a className="carousel-control-prev" href="#carouselExampleControls_in" role="button" data-slide="prev">
                                                        <span className="carousel-control-prev-icon" aria-hidden="true" /> 
                                                        <span className="sr-only">Previous</span>
                                                      </a>
                                                      <a className="carousel-control-next" href="#carouselExampleControls_in" role="button" data-slide="next">
                                                        <span className="carousel-control-next-icon" aria-hidden="true" />
                                                        <span className="sr-only">Next</span>
                                                      </a>
                                                  </div>
                                            
                                              </div>  
    
                                              <div id="golden_in">

                                                  <div id="carouselExampleControlsg_in" className="carousel slide" data-ride="carousel">
                                                      <div className="carousel-inner">
                                                        
                                                        <div className="carousel-item active">
                                                            <div className="row">
                                                                <div className="col-md-3 offset-md-3">
                                                                 <br></br>
                                                                 <img src={golden} width="150" />
                                                                </div>
                                                                
                                                                <div className="col-md-6">                                                            
                                                                    <br></br>
                                                                    <h4 id="espacios"><b id="titulo_plan" >Membresía Golden</b></h4>                                                             
                                                                    <div className="input-group-append">                                                                   
                                                                        <p id="texto"> para 12 meses</p>       
                                                                    </div>                                                            
                                                                                       
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg>  
                                                                            <p id="espacios"> &nbsp; Telemedicina Interactiva</p>       
                                                                        </div>                                                     
                                                                                            
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg> 
                                                                            <p id="espacios"> &nbsp; Acceso ilimitado de usuarios</p>          
                                                                        </div>
                                                                        <div className="input-group-append">
                                                                           <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="4.7338mm" height="7.297mm" version="1.1" style={{shapeRendering: 'geometricPrecision', textRendering: 'geometricPrecision', imageRendering: 'optimizeQuality', fillRule: 'evenodd', clipRule: 'evenodd'}} viewBox="0 0 1491.56 901.1" xmlnsXlink="http://www.w3.org/1999/xlink">
                                                                              <defs>
                                                                                <style type="text/css" dangerouslySetInnerHTML={{__html: "\n   \n    .fil0 {fill:#C2185B}\n   \n  " }} />
                                                                              </defs>
                                                                              <g id="Capa_x0020_1">
                                                                                <metadata id="CorelCorpID_0Corel-Layer" />
                                                                                <g id="_1482714532112">
                                                                                  <path className="fil0" d="M1195.38 678.72c37.5,27.98 153.29,120.4 186.77,133.95 48.82,19.77 89.76,-6.07 104.95,-41.3 4.25,-38.09 4.72,-177.97 4.38,-311.46 0.35,-133.48 -0.13,-273.36 -4.38,-311.45 -15.18,-35.23 -56.13,-61.08 -104.95,-41.31 -33.48,13.55 -149.27,105.98 -186.77,133.96 -61.88,46.18 -81.65,69.93 -81.65,115.71l0 103.09 0 103.09c0,45.79 19.77,69.53 81.65,115.72z" />
                                                                                  <path className="fil0" d="M203.6 0l593.82 0c111.98,0 203.61,91.61 203.61,203.59l0 493.92c0,111.97 -91.63,203.59 -203.61,203.59l-593.82 0c-111.97,0 -203.6,-91.62 -203.6,-203.59l0 -493.92c0,-111.98 91.63,-203.59 203.6,-203.59z" />
                                                                                </g>
                                                                              </g>
                                                                            </svg> 
                                                                            <p id="espacios"> &nbsp; Incluye 14.840 Minutos en videollamadas</p>         
                                                                        </div> 
                                                                        <div className="input-group-append">
                                                                            
                                                                          <h5><p id="espacios"> USD $544 / ANUAL</p></h5>           
                                                                        </div> 

                                                                        <a id="btn-verdetalle" className="btn"  onClick={()=> this.modal_detalle_golden_independiente()} >
                                                                            Ver detalles
                                                                        </a>

                                                                        <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                                                         COMPRAR
                                                                        </button>
                                                                        <br></br>                                                                                   
                                                                
                                                                </div>
                                                            </div>
                                                           
                                                        </div>
                                                        
                                                      </div>
                                                      <a className="carousel-control-prev" href="#carouselExampleControlsg_in" role="button" data-slide="prev">
                                                        <span className="carousel-control-prev-icon" aria-hidden="true" /> 
                                                        <span className="sr-only">Previous</span>
                                                      </a>
                                                      <a className="carousel-control-next" href="#carouselExampleControlsg_in" role="button" data-slide="next">
                                                        <span className="carousel-control-next-icon" aria-hidden="true" />
                                                        <span className="sr-only">Next</span>
                                                      </a>
                                                  </div>
                                            
                                              </div>    
                                                                                                                                 
                                         
                                          </div>   

                                    </div>
                                      
                              </div>
                              
                          </div>


                  </div>

            </div>



            <div className="modal fade" id="modal_img_perfil">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title"><b>Imagen de perfil</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
    
                    <div className="modal-body">
                        
                          <div className="row"> <br/>

                              <img src={files_view} id="act_avatar" alt="logo" width= "440" className="rounded-circle"/>
                                                  
                          
                          </div>

                    </div> 
    
                    <div className="modal-footer justify-content-between">      
                                                        
                          <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.subir_avatar()}>{this.state.loading_button_img?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Guardar</button>            
                          <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.drop_view_img}>Cerrar</button>
                             
                    </div>

                  </div>                  
                </div>                
              </div> 


              <div className="modal fade" id="modal_img_portada">
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="modal-title"><b>Imagen de portada</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
    
                    <div className="modal-body">
                        
                          <div className="row"> <br/>
                               
                              <img src={files_viewp} alt="logo" width= "750" className="rounded"/>
                                                  
                          
                          </div>

                    </div> 
    
                    <div className="modal-footer justify-content-between">      
                                                        
                          <button type="button" className="btn btn-primary" disabled={!this.state.active_button}  onClick={()=> this.subir_portada()}>{this.state.loading_button_img?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Guardar</button>
                          <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.drop_view_img}>Cerrar</button>
                             
                    </div>

                  </div>                  
                </div>                
              </div> 



              <div className="modal fade" id="modal-infoinstotucion">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h4 className="modal-title"><b>Editar información de la institución</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>

                      <div className="modal-body">
    
                            <div className="row">
                
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Nombre prestador:</label>
                                          <input type="text" className="form-control" name="nombre_edit" value={form.nombre_edit} onChange={this.handleChange} />                      
                                        </div>                 
                                  </div>

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Nit:</label>
                                          <input type="text" className="form-control"  name="codigoprestador_edit" value={this.state.DataIntitucion.nit+"-"+this.state.DataIntitucion.dv} readOnly />                      
                                        </div>                 
                                  </div> 
    
                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Código prestador:</label>
                                          <input type="text" maxLength="12" className="form-control camponum"  name="codigoprestador_edit" onChange={this.handleChange} onKeyDown={this.Campo_numerico()} value={form.codigoprestador_edit} />                      
                                        </div>                 
                                  </div>                          
                
                            </div>
                        
                            <div className="row">
                
                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Dirección:</label>
                                          <input type="text" className="form-control" name="dir_edit" value={form.dir_edit} onChange={this.handleChange}/>                      
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Telefono 1:</label>
                                          <input type="text" maxLength="15" className="form-control camponum" name="tel1_edit" value={form.tel1_edit} onChange={this.handleChange}/>                      
                                        </div>                 
                                  </div>

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Telefono 2:</label>
                                          <input type="text" maxLength="15" className="form-control camponum" name="tel2_edit" value={form.tel2_edit} onChange={this.handleChange}/>                      
                                        </div>                 
                                  </div>                  
                
                            </div>
                
                            <div className="row">
                
                                  <div className="col-md-6">              
                                      <div className="form-group">                    
                                              <label >Pagina web:</label>
                                              <input type="text" className="form-control" name="web_edit" value={form.web_edit} onChange={this.handleChange}/>
                                      </div>              
                                  </div>
                                                    
                                  <div className="col-md-3">                
                                        <div className="form-group">                    
                                            <label >Departamento:</label>
                                            <select onChange={this.GetDepartamento}  className="form-control">
                                               <option id="cb_departamento" value={iddepa_edit}>{depa}</option>  
                                               {this.state.Departamentos.map(item=>                              
                                               <option key={item.id} value={item.id}> {item.nombre.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                               )}                                                                                  
                                            </select>                                                                 
                                        </div>                                             
                                  </div>

                                  <div className="col-md-3">                
                                        <div className="form-group">                    
                                            <label >Municipio:</label>
                                            <select onChange={this.GetMunicipio}  className="form-control">
                                               {/* <option id="cb_municipio_seleccione"  value="0">Seleccione...</option> */}
                                               <option id="cb_municipio"  value={idmuni_edit}>{muni}</option>  
                                               {this.state.Municipios.map(item=>                              
                                                <option key={item.id} value={item.id}> {(item.nombre).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                                )}                                                                                  
                                            </select>                                                                 
                                        </div>                                             
                                  </div>
                
                            </div>

                            <div className="row">
                
                                  <div className="col-md-3">                
                                        <div className="form-group">                    
                                            <label >Clase de prestador:</label>
                                            <select onChange={this.GetClasepres} onClick={this.GetClasepres}  className="form-control">
                                                  <option id="cb_claseprestador" value={claseprestador_edit}>{this.state.claseprestado}</option>  
                                                  <option  value="ips">Instituciones - IPS</option> 
                                                  <option  value="profesional independiente">Profesional independiente</option>
                                                  <option  value="transporte Especial de Pacientes">Transporte Especial de Pacientes</option>
                                                                                                                               
                                            </select>                                                                 
                                        </div>                                             
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Naturaleza jurídica:</label>
                                          <select onChange={this.GetTipoNatu} onClick={this.GetTipoNatu}  className="form-control">
                                                <option id="cb_naturaleza" value={naturaleza_edit}>{(naturaleza_edit).trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                                <option  value="privada">Privada</option> 
                                                <option  value="publica">Pública</option>
                                                <option  value="mixta">Mixta</option>                                                                               
                                          </select>
                                        </div>                 
                                  </div>

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Nivel de atención:</label>
                                          <select onChange={this.GetNivel} onClick={this.GetNivel}  className="form-control">
                                                <option id="cb_nivel" value={nivelatencion_edit}>{nivelatencion_edit}</option>  
                                                <option  value="1">1</option>
                                                <option  value="2">2</option> 
                                                <option  value="3">3</option>                                                                               
                                          </select>
                                        </div>                 
                                  </div>   

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Empresa social del estado:</label>
                                          <select onChange={this.GetESE} onClick={this.GetESE}  className="form-control">
                                                <option id="cb_ese" value={this.state.DataIntitucion.ese}>{ese}</option>  
                                                <option  value="false">No</option>
                                                <option  value="true">Si</option>                                                                               
                                          </select>
                                        </div>                 
                                  </div>               
                
                            </div>

                            <b>Datos del representante legal:</b>
                            <br/><br/>

                            <div className="row"> 
                
                                  <div className="col-md-6">                
                                        <div className="form-group">                    
                                            <label >Tipo ID:</label>
                                            <select onChange={this.GetTipoIDLD} onClick={this.GetTipoIDLD}  className="form-control">
                                                  <option id="cb_tipoid_rl" value={tipoidrl_edit}>{tipoidrl_edit}</option> 
                                                  <option  value="CC">Cédula de ciudadania</option> 
                                                  <option  value="CE">Cédula de extrangeria</option>  
                                                                                                                               
                                            </select>                                                                 
                                        </div>                                             
                                  </div> 

                                  <div className="col-md-6">
                                        <div className="form-group">                    
                                          <label >Numero ID:</label>
                                          <input type="text" maxLength="10" className="form-control camponum" name="idrl_edit" value={form.idrl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div>       
                
                            </div>

                            <div className="row">                      

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Primer nombre:</label>
                                          <input type="text" className="form-control" name="nom1rl_edit" value={form.nom1rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Segundo nombre legal:</label>
                                          <input type="text" className="form-control" name="nom2rl_edit" value={form.nom2rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Primer apellido:</label>
                                          <input type="text" className="form-control" name="apell1rl_edit" value={form.apell1rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div> 

                                  <div className="col-md-3">
                                        <div className="form-group">                    
                                          <label >Segundo apellido:</label>
                                          <input type="text" className="form-control" name="apell2rl_edit" value={form.apell2rl_edit} onChange={this.handleChange}/>
                                        </div>                 
                                  </div>             
                
                            </div>                
                
                      </div>
                
                      <div className="modal-footer justify-content-between">
                        <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.saveinstitution()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Guardar</button>
                        <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>        
                      </div>
                    </div>
                    
                  </div>
              
              </div> 


              <div className="modal fade" id="modal-activarmembresia">
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h4 className="col-11 modal-title text-center" id="correo_activacion"><b>Activar membresía</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
    
                    <div className="modal-body">                       

                          <div className="row">                           
                                          
                              <div className="col-md-12">
                                  <div className="form-group"> 

                                          <label >Ingresa el código de la membresía:</label>
                                      
                                  </div>          
                              </div>

                          </div> 

                          <div className="row justify-content-md-center"> <br/>                                      
                              
                                 
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia1" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia2" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia3" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia4" id="cod_membresia" onChange={this.handleChange}/>_
                              <input type="text" className="form-control" maxLength="5" name="cod_membresia5" id="cod_membresia" onChange={this.handleChange}/>
                              
                             
              
                          </div>

                          <div className="col-md-12 text-center"> <br/>
                                  <button type="submit" id="btn-activacuenta" className="btn"  disabled={!this.state.active_button} onClick={()=> this.Activar_membresia()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Activar</button>                     
                          </div>
    
                              
                    </div> 
    
                  </div>
                  
                </div>
                
              </div>


              <div className="modal fade" id="modal-llaveswompi" data-backdrop="static">

                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header" id="fondo_modal_compra">
                      <h4 className="col-11 modal-title text-center" id="correo_activacion"><b>Llaves asociadas a Wompi</b></h4>
                      <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=> this.Datos_Institucion()}>
                        <span aria-hidden="true">×</span>
                      </button>
                    </div>
                    <div className="modal-body">
  
                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Llave pública</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_publi" autoComplete='nope' value={form.llave_publi} onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde a la llave pública asignada por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Llave privada</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_priv" autoComplete='nope' value={form.llave_priv}  onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde a la llave privada asignada por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Eventos</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_eventos"  onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde al secreto eventos asignado por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <div className="col-md-12">
                                  <div className="form-group"> 

                                    <label >Integridad</label>

                                    <div className="input-group">
                                        <input type="text" maxLength="50" className="form-control" name="llave_integridad"  onChange={this.handleChange} />
                                        <div className="input-group-append">
                                             <button id="icono_crea" className="btn btn-primary form-control-md" type="button" data-toggle="tooltip" data-placement="top" title="Corresponde al secreto integridad asignado por Wompi." > <span className="fas fa-info-circle"></span> </button>
                                        </div>                                                                          
                                        
                                    </div>                                                              
                                                          
                                 </div>                 
                          </div>

                          <p type="button" class="btn btn-secondary" id="campos_obligatorios"><b id="asterisco">*</b> <a id="btn-registrarse" href="https://comercios.wompi.co/developers" target="_blank"> Para mas información ingresa a: https://comercios.wompi.co/developers </a> </p>
                                 
                    </div>
          
                          <div className="modal-footer justify-content-between">        
                             <button type="button" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.save_llavesWOMPI()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />}Registrar</button>
                             <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.Datos_Institucion()}>Cerrar</button>
                          </div>
                  </div>                
                </div>
            
              </div>


              <div className="modal fade" id="modal-compramembresia">

                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header" id="fondo_modal_compra">
                        <h4 className="col-11 modal-title text-center"><b>{this.state.Detalle_membresia.name}</b></h4>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">×</span>
                        </button>                       
                      </div>    
    
                      <form>                               

                          <div className="modal-body">
                              
                              <div id="compra_paso1">


                                      <div className="d-flex justify-content-center">              
                                                                                                 
                                            <img src={paso1} />                                                             
                                
                                      </div>

                                       
                                      <br/> 

                                      <div className="row justify-content-md-center">

                                            <div className="col-lg-12">

                                                <div className="card" id="card_body">
                                                      <div className="card-header text-center">
                                                         <b>Detalle del producto</b> <br/>
                                                      </div>
                                                      <div className="card-body">
                                                          <div className="row d-flex justify-content-center">
                                                       
                                                              <div className="col col-lg-5 text-right">                                                                      
                                                                 
                                                                  <b>Subtotal: $</b> <br/>
                                                                  <b>IVA: $</b> <br/>
                                                                  <b>Total: $</b> <br/>


                                                              </div> 
                                                              <div className="col-sm-6">                                                                      
                                                                 
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_membresia.priceCOP))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_membresia.percentIVA))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_membresia.priceCOP))}</b> <br/>


                                                              </div>          
    
                                                          </div>
                                                      </div>
                                                </div>
            
                                            </div>
                                  
                                      </div>
                                      
                                      <div className="row justify-content-md-center">

                                          <div className="col-md-5">                
                                                <div className="form-group">                    
                                                    <label > <h5>Datos del comprador</h5></label>
                                                                                                                 
                                                </div>                                             
                                          </div> 
                                  
                                      </div>  

                                      <div className="row">

                                            <div className="col-md-6">
                                                  <div className="form-group"> 

                                                        <label >Tipo ID</label>
                                                        <select  className="form-control" name="tipoid_comprador_general" id="tipoid_comprador_general" onChange={this.handleChange}  required>                                                          
                                                           <option  value="null">Seleccione...</option> 
                                                           <option  value="CC">Cédula de ciudadania</option> 
                                                           <option  value="CE">Cédula de extrangeria</option>
                                                           <option  value="NIT">NIT</option>                    
                                                        </select>
                                                                            
                                                  </div>                 
                                            </div> 
                          
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Identificación</label>
                                                    <input type="text" className="form-control" name="id_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>
              
                                      </div> 
        
                                      <div className="row">
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Nombres</label>
                                                    <input type="text" className="form-control" name="nombres_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div> 
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Apellidos</label>
                                                    <input type="text" className="form-control" name="apellidos_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                         
                          
                                      </div>
                            
                                      <div className="row">
                          
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Enviaremos el código de activación a este correo</label>
                                                    <input type="email" className="form-control" name="correo_comprador_general" onChange={this.handleChange} value={this.state.DataIntitucion.email} readOnly/>                      
                                                  </div>                 
                                            </div>                   
                          
                                      </div>
                    
                                      <div className="row">
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Dirección</label>
                                                    <input type="text" className="form-control" name="dir_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div> 
              
                                            <div className="col-md-6">
                                                  <div className="form-group">                    
                                                    <label >Telefono</label>
                                                    <input type="text" className="form-control" name="tel_comprador_general" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                         
                          
                                      </div>
                              </div>

                              <div id="compra_paso2">

                                <div className="row">                                      
                                                                                           
                                      <img src={paso2} />                                                                
                          
                                </div>

                                <br/> 

                                <div className="row justify-content-md-center">

                                      <div className="col-md-7">                
                                            <div className="form-group">                    
                                                <label > <h5>Seleccione un método de pago</h5></label>
                                                                                                             
                                            </div>                                             
                                      </div> 
                                  
                                </div>  
                                            
                                <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="CARD" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios1">  Tarjeta de crédito  </label>
                                            <div className="input-group-append">
                                                  <img src={card_credit} />
                                            </div>
                                      </div>                                                        
                                           
                                </div> 

                                <br/>

                                <div className="row justify-content-md-center" id="tarjeta_credito">

                                    <div className="col-sm-12">
                                      

                                      <div className="row">
              
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Número completo de la tarjeta (sin espacios)</label>
                                                    <input type="text" className="form-control" name="num_tc" placeholder="4400330022001100" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                        
                          
                                      </div>

                                      <div className="row">
              
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Nombre en la tarjeta</label>
                                                    <input type="text" className="form-control" maxLength="30" name="tarjetahabiente" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                        
                          
                                      </div>

                                      <div className="row">
              
                                            <div className="col-md-4">
                                                  <div className="form-group"> 

                                                        <label >Fecha de expiración</label>
                                                        <div className="input-group">

                                                              <div className="input-group-append">
      
                                                                    <select  onChange={this.handleChange}  className="form-control" name="mes_tc" id="mes_tc" >                                                          
                                                                       <option  value="MM">MM</option>
                                                                       <option  value="01">01</option> 
                                                                       <option  value="02">02</option>
                                                                       <option  value="03">03</option>
                                                                       <option  value="04">04</option> 
                                                                       <option  value="05">05</option>
                                                                       <option  value="06">06</option>  
                                                                       <option  value="07">07</option> 
                                                                       <option  value="08">08</option>
                                                                       <option  value="09">09</option>  
                                                                       <option  value="10">10</option> 
                                                                       <option  value="11">11</option>
                                                                       <option  value="12">12</option>                      
                                                                    </select>
      
                                                              </div>

                                                              <div className="input-group-append">
      
                                                                    <select  onChange={this.handleChange}  className="form-control" name="year_tc" id="year_tc" >                                                          
                                                                       <option  value="YY">YY</option>                                                                       
                                                                       <option  value="23">23</option> 
                                                                       <option  value="24">24</option> 
                                                                       <option  value="25">25</option>
                                                                       <option  value="26">26</option>
                                                                       <option  value="27">27</option> 
                                                                       <option  value="28">28</option>
                                                                       <option  value="29">29</option>
                                                                       <option  value="30">30</option> 
                                                                       <option  value="31">31</option>
                                                                       <option  value="32">32</option>                                                                            
                                                                    </select>
      
                                                              </div>
                                                        </div>                                                    
                                                                            
                                                  </div>                 
                                            </div> 

                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                        <label >Cuotas</label>
                                                        <select  onChange={this.handleChange} className="form-control" name="cuotas_tc"  id="cuotas_tc">                                                         
                                                           <option  value="1">1</option> 
                                                           <option  value="2">2</option> 
                                                           <option  value="3">3</option> 
                                                           <option  value="4">4</option>
                                                           <option  value="5">5</option> 
                                                           <option  value="6">6</option>
                                                           <option  value="7">7</option> 
                                                           <option  value="8">8</option>  
                                                           <option  value="9">9</option> 
                                                           <option  value="10">10</option>
                                                           <option  value="11">11</option> 
                                                           <option  value="12">12</option>                                                                     
                                                        </select>
                                                                              
                                                     </div>                 
                                            </div>

                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                    <label >Código de seguridad</label>
                                                    <input type="text" maxLength="3" className="form-control" name="cod_tc" placeholder="000" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div> 

                                      </div>

                                      <hr></hr>

                                    </div>

                                </div>

                                                      
                                <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="PSE" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios2">  PSE  </label>
                                            <div className="input-group-append">
                                                  <img src={pse} />
                                            </div>
                                      </div>                                                        
                                           
                                </div> 

                                <br/>  

                                <div className="row justify-content-md-center" id="pse">

                                    <div className="col-sm-12">

                                      {/* <div className="row">              
                                           
              
                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                        <label >Tipo de documento</label>
                                                        <select onChange={this.handleChange} className="form-control" name="tipodcto_pse"  className="form-control">                                                         
                                                           <option  value="CC">CC</option> 
                                                           <option  value="NIT">NIT</option>                                                                        
                                                        </select>
                                                                              
                                                     </div>                 
                                            </div>  

                                            <div className="col-md-8">
                                                  <div className="form-group">                    
                                                    <label >Número de documento</label>
                                                    <input type="text" maxLength="10" className="form-control" name="numerodcto_pse"  onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>                      
                          
                                      </div> */}


                                      <div className="row">

                                            <div className="col-md-4">
                                                  <div className="form-group">                    
                                                        <label >Tipo de persona</label>
                                                        <select onChange={this.GetTipopersona} className="form-control" name="tipo_persona_pse"  id="tipo_persona_pse">                                                         
                                                           <option  value="">Seleccione...</option>
                                                           <option  value="0">Natural</option> 
                                                           <option  value="1">Júridica</option>                                                                        
                                                        </select>
                                                                              
                                                     </div>                 
                                            </div> 
              
                                            <div className="col-md-8">                                                                          
                                                    <div className="form-group">                    
                                                        <label >Banco</label> 
                                                        <select onChange={this.handleChange} className="form-control" name="id_banco_pse" id="id_banco_pse">
                                                            <option  value=""> Seleccione...</option> ,
                                                            {this.state.Bancos.map(banco=>                              
                                                            <option key={banco.financial_institution_code} value={banco.financial_institution_code}> {banco.financial_institution_name.toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}</option>  
                                                            )}
                                                                    
                                                        </select>                                                                         
                                                        
                                                    </div>                                        
                                            </div> 
              
                                                                   
                          
                                      </div>

                                      <hr></hr>

                                    </div>

                                </div>                                  
                                                      
                                <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="BANCOLOMBIA_TRANSFER" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios3">  Bancolombia  </label>
                                            <div className="input-group-append">
                                                  <img src={bancolombia} />
                                            </div>
                                      </div>                                                        
                                           
                                </div> 

                                <br/>
                                                                 
                                                      
                              {/*  <div className="form-check">
                                      <div className="input-group">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios4" value="NEQUI" onClick={this.GetMetodopago}/>
                                            
                                            <label className="form-check-label" for="exampleRadios4">  Nequi  </label>
                                            <div className="input-group-append">
                                                  <img src={nequi} />
                                            </div>
                                      </div>                                                                                                        
                                           
                                </div> 

                                <br/> 

                                <div className="row justify-content-md-center" id="nequi">

                                    <div className="col-sm-12">

                                      <div className="row"> 
                          
                                            <div className="col-md-12">
                                                  <div className="form-group">                    
                                                    <label >Numero de celular (cuenta Nequi)</label>
                                                    <input type="text" maxLength="10" className="form-control" name="cel_nequi" onChange={this.handleChange} required />                      
                                                  </div>                 
                                            </div>
              
                                      </div>  

                                    </div>        

                                                            </div>  */}

                              </div>
                    
                          </div>

                          <div id="compra_paso3">


                                      <div className="d-flex justify-content-center">              
                                                                                                 
                                            <img src={paso3} />                                                                
                                
                                      </div>

                                       
                                      <br/> 

                                      <div className="row justify-content-md-center">

                                            <div className="col-lg-12">

                                                <div className="card" id="card_body">
                                                      <div className="card-header text-center">
                                                         <b>Detalle de la compra</b> <br/>
                                                      </div>
                                                      <div className="card-body">
                                                          <div className="row d-flex justify-content-center">
                                                       
                                                              <div className="col col-lg-5 text-right">                                                                      
                                                                 
                                                                  <b>Subtotal: </b> <br/>
                                                                  <b>IVA: </b> <br/>
                                                                  <b>Valor de la transacción: </b> <br/>
                                                                  <b>Total: </b> <br/>


                                                              </div> 
                                                              <div className="col-sm-6">                                                                      
                                                                 
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.subtotal))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.iva))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.commission))}</b> <br/>
                                                                  <b>{(new Intl.NumberFormat("es-CO", {style: "currency", currency: "COP", minimumFractionDigits: 0}).format(this.state.Detalle_compra.total))}</b> <br/>


                                                              </div>          
    
                                                          </div>
                                                      </div>
                                                </div>
            
                                            </div>
                                  
                                      </div>                                      
                                     
                              </div>
                                
                    
                          <div className="modal-footer justify-content-between" id="btn_compra_paso1">

                                <button type="button" id="btn_compra" className="btn btn-danger" data-dismiss="modal" onClick={()=> this.dropmodal_comprar_membresia()}>Cancelar</button>
                                <button type="submit" id="btn_compra" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.validar_paso1()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Método de pago
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short" viewBox="2 3 10 10">
                                          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg> 
                                </button>

                          </div>

                          <div className="modal-footer justify-content-between" id="btn_compra_paso2">                         

                                <button type="button" id="btn_compra" className="btn btn-danger" onClick={()=> this.atras()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="currentColor" class="bi bi-arrow-left-short" viewBox="3 3 10 10">
                                          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                                        </svg>
                                        Atras
                                </button>
                                <button type="button" id="btn_compra" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.Validar_formularios_compra()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Continuar
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short" viewBox="2 3 10 10">
                                          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg> 
                                </button>

                            
                                    
                          </div>

                          <div className="modal-footer justify-content-between" id="btn_compra_paso3">                         

                                <button type="button" id="btn_compra" className="btn btn-danger" onClick={()=> this.atras3()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18" fill="currentColor" class="bi bi-arrow-left-short" viewBox="3 3 10 10">
                                          <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                                        </svg>
                                        Atras
                                </button>
                                <button type="submit" id="btn_compra" className="btn btn-primary" disabled={!this.state.active_button} onClick={()=> this.ComprarMembresia()}> {this.state.loading_button?false:<ReactBootStrap.Spinner animation="border" size="sm" />} Pagar
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-arrow-right-short" viewBox="2 3 10 10">
                                          <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
                                        </svg> 
                                </button>

                            
                                    
                          </div>

                      </form>

                    </div>
                    
                  </div>
              
              </div> 

              <div className="modal fade" id="modal_detalle_silver_independiente" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Silver Professional</b> <br/> <b>395 USD / 7.920  Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="2")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_golden_independiente" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Golden Professional</b> <br/> <b>544 USD / 15.840 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_platinum_institucion" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Platinum Business</b> <br/> <b>791 USD / 15.840 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>No</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="2")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_golden_institucion" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Golden Business</b> <br/> <b>1.087 USD / 31.680 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="3")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>

              <div className="modal fade" id="modal_detalle_diamond_institucion" data-backdrop="static">
                  <div className="modal-dialog modal-lg modal-dialog-scrollable">
                      <div className="modal-content">
                          <div className="modal-header" id="fondo_modal_compra">
                            <h4 className="col-11 modal-title text-center"><b>Membresía Diamond Business</b> <br/> <b>1.384 USD / 63.360 Minutos</b></h4> 
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">×</span>
                            </button>                       
                          </div>
                        
                          <div className="modal-body">
                             
                            <table id="example1" className="table table-bordered table-striped table-hover">
                                                     
                                <thead>
                                    <tr>
                                      
                                      <th>Servicios que incluye la membresía</th>
                                      <th>1 Año</th>
                                        
                                               
                                    </tr>
                                </thead>
                                <tbody>                                              
                                
                            
                                    <tr>                                 
                                      <td>Usuarios que pueden ingresar al portal para prestadores de salud</td>
                                      <td>Ilimitado</td>
                                    </tr>
    
                                    <tr>                                 
                                      <td>Profesionales y/o especialistas que pueden atender mediante Telemedicina 	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Tablero de indicadores e informes 	 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar solicitudes de pacientes que quieran hacer consultas por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar la asignación de citas ambulatorias que sean solicitadas por los pacientes con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para gestionar las solicitudes de pacientes que quieran hacer consultas particulares 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para configurar el perfil del prestador y actualizar su membresía		</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear contratos con EPS, hacer los consentimientos informados, crear usuarios, fijar montos de cuotas moderadoras, crear servicios y establecer los horario de atención del prestador 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para publicaciones de contenido en imágenes y videos del prestador	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear turnos de agendas de profesionales y especialistas que brindan el servicio de Telemedicina de forma ambulatoria	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista para crear los convenios del prestador con los profesionales y especialistas que brindan el servicio de Telemedicina	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Vista del registro de historias clínicas realizado en urgencia y consulta externa 	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para consultar historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de historias clínicas	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Grabación automática de videollamada</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Composición de grabaciones de videollamada	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Descarga gratuita de las grabaciones del video de las consultas realizadas	</td>
                                      <td>Ilimitado</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran consultar por urgencia con cargo a su EPS	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas realicen videollamadas a los pacientes con citas ambulatorias programadas con cargo a su EPS</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Permisos para que los profesionales y especialistas reciban videollamadas de pacientes que quieran hacer consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de cuotas moderadoras	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Botón de pago para el recaudo de consultas particulares	</td>
                                      <td>Si</td>
                                    </tr>

                                    <tr>                                 
                                      <td>Almacenamiento de recurso</td>
                                      <td>Si</td>
                                    </tr>
                                   
                          
                                </tbody>
    
                            </table>

                            <div className="d-flex justify-content-center">                                                
                                <button type="submit" id="btn-comprar" className="btn"  onClick={()=> this.modal_comprar_membresia(tipo_membresia="4")}>
                                   COMPRAR
                                </button>                           
                            </div>

                          </div>    
                      </div>
                  </div>  
              </div>


              <div className="modal fade" id="modal-loader" data-backdrop="static">
                  <div className="modal-dialog modal-lg">
                    
                        <br/> <br/> <br/> <br/>
                   
                        <div className="d-flex justify-content-center">                                                
                              {this.state.loading_recurso?false: <ReactBootStrap.Spinner animation="grow"/>}                        
                        </div>
      
                        <div className="d-flex justify-content-center">                                                
                              <spam id="spamloader"> <h2>Procesando la compra</h2> </spam>                           
                        </div>                      
                    
                  </div>
  
              </div>

</div>
      
    )

  }
  
}



export default Perfil;